import styled, { css, createGlobalStyle, keyframes, StyleSheetManager } from 'styled-components';
import { math, rem, transparentize, rgba, borderRadius } from 'polished';
import React, { useState, useEffect, useRef, useCallback, useContext, createContext } from 'react';
import { getParser } from 'bowser';
import { ArrowRight } from '@styled-icons/bootstrap/ArrowRight';
import { CalendarCheckFill } from '@styled-icons/bootstrap/CalendarCheckFill';
import { ChatDotsFill } from '@styled-icons/bootstrap/ChatDotsFill';
import { ChatSquareTextFill } from '@styled-icons/bootstrap/ChatSquareTextFill';
import { FileEarmarkCheckFill as FileEarmarkCheckFill$1 } from '@styled-icons/bootstrap/FileEarmarkCheckFill';
import { HourglassSplit } from '@styled-icons/bootstrap/HourglassSplit';
import { InfoCircleFill } from '@styled-icons/bootstrap/InfoCircleFill';
import { QuestionCircleFill } from '@styled-icons/bootstrap/QuestionCircleFill';
import { ShareFill } from '@styled-icons/bootstrap/ShareFill';
import { StarFill } from '@styled-icons/bootstrap/StarFill';
import { Whatsapp as Whatsapp$1 } from '@styled-icons/boxicons-logos/Whatsapp';
import { Face as Face$1 } from '@styled-icons/boxicons-solid/Face';
import { MessageAltError } from '@styled-icons/boxicons-solid/MessageAltError';
import { SelectMultiple } from '@styled-icons/boxicons-solid/SelectMultiple';
import { FacebookWithCircle } from '@styled-icons/entypo-social/FacebookWithCircle';
import { InstagramWithCircle } from '@styled-icons/entypo-social/InstagramWithCircle';
import { LinkedinWithCircle } from '@styled-icons/entypo-social/LinkedinWithCircle';
import { MailWithCircle } from '@styled-icons/entypo-social/MailWithCircle';
import { CloseCircleOutline as CloseCircleOutline$1 } from '@styled-icons/evaicons-outline/CloseCircleOutline';
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline';
import { ArrowIosDownward } from '@styled-icons/evaicons-solid/ArrowIosDownward';
import { CloseCircle as CloseCircle$1 } from '@styled-icons/evaicons-solid/CloseCircle';
import { MinusCircle as MinusCircle$1 } from '@styled-icons/evaicons-solid/MinusCircle';
import { PlusCircle as PlusCircle$1 } from '@styled-icons/evaicons-solid/PlusCircle';
import { HouseLaptop } from '@styled-icons/fa-solid/HouseLaptop';
import { NotesMedical } from '@styled-icons/fa-solid/NotesMedical';
import { ShieldVirus } from '@styled-icons/fa-solid/ShieldVirus';
import { User as User$1 } from '@styled-icons/fa-solid/User';
import { UserNurse } from '@styled-icons/fa-solid/UserNurse';
import { Users as Users$1 } from '@styled-icons/fa-solid/Users';
import { ChatBubblesQuestion } from '@styled-icons/fluentui-system-filled/ChatBubblesQuestion';
import { CheckboxChecked } from '@styled-icons/fluentui-system-filled/CheckboxChecked';
import { DeleteDismiss } from '@styled-icons/fluentui-system-filled/DeleteDismiss';
import { Doctor as Doctor$1 } from '@styled-icons/fluentui-system-filled/Doctor';
import { HandDraw as HandDraw$1 } from '@styled-icons/fluentui-system-filled/HandDraw';
import { NotebookQuestionMark } from '@styled-icons/fluentui-system-filled/NotebookQuestionMark';
import { Password as Password$1 } from '@styled-icons/fluentui-system-filled/Password';
import { SendClock } from '@styled-icons/fluentui-system-filled/SendClock';
import { Timer as Timer$1 } from '@styled-icons/fluentui-system-filled/Timer';
import { Xray as Xray$1 } from '@styled-icons/fluentui-system-filled/Xray';
import { MagnifyingGlass } from '@styled-icons/foundation/MagnifyingGlass';
import { Telephone as Telephone$1 } from '@styled-icons/foundation/Telephone';
import { LocationMarker } from '@styled-icons/heroicons-solid/LocationMarker';
import { MenuAlt1 } from '@styled-icons/heroicons-solid/MenuAlt1';
import { RefreshCircle as RefreshCircle$1 } from '@styled-icons/ionicons-sharp';
import { Warning as Warning$1 } from '@styled-icons/ionicons-solid/Warning';
import { Bloodtype } from '@styled-icons/material/Bloodtype';
import { Edit as Edit$1 } from '@styled-icons/material/Edit';
import { MapsHomeWork } from '@styled-icons/material/MapsHomeWork';
import { CloudUpload } from '@styled-icons/material-rounded/CloudUpload';
import { Email } from '@styled-icons/material-rounded/Email';
import { Schedule } from '@styled-icons/material-rounded/Schedule';
import { ChatFollowUp } from '@styled-icons/remix-fill/ChatFollowUp';
import { RestTime } from '@styled-icons/remix-fill/RestTime';
import { SecurePayment } from '@styled-icons/remix-fill/SecurePayment';
import ReactSelect, { components } from 'react-select';
import ReactCalendar from 'react-calendar';
import Carousel$1, { ScrollMode } from 'nuka-carousel';
import InputMask from 'react-input-mask';
import { nanoid } from 'nanoid';
import showdown from 'showdown';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$z;
var firefoxOnly = function firefoxOnly(cssRules) {
  return css(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  @-moz-document url-prefix() {\n    ", "\n  }\n"])), cssRules);
};

var borderWidths = {
  thin: '0.1rem',
  small: '0.2rem'
};

var colors = {
  primary: '#29E4C6',
  secondary: '#823AFB',
  dark: '#0D1053',
  light: '#FFFFFF',
  neutral: '#A6A6A6',
  new_neutral_light: '#DEDEDE',
  neutral_light: '#F0F1F5',
  neutral_extra_light: '#F6F6F6',
  text__primary: '#0D1053',
  text__secondary: '#29E4C6',
  text__highlight: '#823AFB',
  text__light: '#FFFFFF',
  text__link: '#35BAEC',
  gradient__primary: 'linear-gradient(90deg, #35BAEC 0%, #28E7C2 100%)',
  gradient__primary_reverse: 'linear-gradient(90deg, #28E7C2 0%, #35BAEC 100%)',
  gradient__secondary: 'linear-gradient(90deg, #8533FB 0%, #4E88FC 100%)',
  gradient__secondary_reverse: 'linear-gradient(90deg, #4E88FC 0%, #8533FB 100%)',
  gradient__primary_diagonal: 'linear-gradient(135deg, #35BAEC 0%, #28E7C2 100%)',
  gradient__secondary_diagonal: 'linear-gradient(135deg, #8533FB 0%, #4E88FC 100%)',
  gradient_border_color: 'radial-gradient(49% 118.68% at 49.37% -28.38%, #5d5fef 33.62%,rgba(93, 95, 239, 0.6615) 56.09%, rgba(93, 95, 239, 0.2196) 85.43%,rgba(255, 255, 255, 0) 100%)',
  state__success: '#63D159',
  state__warning: '#FF8C59',
  state__error: '#EA5962'
};

var getBrowserParser = function getBrowserParser() {
  var _browser$getBrowser, _browser$getOS, _Number, _browser$getOS2;
  if (typeof window === 'undefined') {
    return {
      currentBrowser: null,
      currentOS: null,
      currentOSVersion: 0
    };
  }
  var browser = getParser(window.navigator.userAgent);
  return {
    currentBrowser: ((_browser$getBrowser = browser.getBrowser()) == null ? void 0 : _browser$getBrowser.name) || null,
    currentOS: ((_browser$getOS = browser.getOS()) == null ? void 0 : _browser$getOS.name) || null,
    currentOSVersion: (_Number = Number((_browser$getOS2 = browser.getOS()) == null ? void 0 : _browser$getOS2.version)) != null ? _Number : 0
  };
};
var useUserDevice = function useUserDevice() {
  var _useState = useState(null),
    browser = _useState[0],
    setBrowser = _useState[1];
  var _useState2 = useState(null),
    OS = _useState2[0],
    setOS = _useState2[1];
  var _useState3 = useState(0),
    OSVersion = _useState3[0],
    setOSVersion = _useState3[1];
  useEffect(function () {
    var _getBrowserParser = getBrowserParser(),
      currentBrowser = _getBrowserParser.currentBrowser,
      currentOS = _getBrowserParser.currentOS,
      currentOSVersion = _getBrowserParser.currentOSVersion;
    setBrowser(currentBrowser);
    setOS(currentOS);
    setOSVersion(currentOSVersion);
  }, []);
  return {
    browser: browser,
    OS: OS,
    OSVersion: OSVersion
  };
};

var _templateObject$y, _templateObject2$w, _templateObject3$o, _templateObject4$m;
var checkOS = function checkOS(os) {
  if (!os) return true;
  var _getBrowserParser = getBrowserParser(),
    currentOS = _getBrowserParser.currentOS;
  return currentOS === os;
};
function generateMedia(breakpoints) {
  var lessThan = function lessThan(breakpoint, os) {
    return function (style) {
      if (!checkOS(os)) return css(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose([""])));
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return css(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n        @media (max-width: ", ") {\n          ", "\n        }\n      "])), math(breakpoints[breakpoint] + " - 1px"), style && css.apply(void 0, [style].concat(rest)));
    };
  };
  var greaterThan = function greaterThan(breakpoint, os) {
    return function (style) {
      if (!checkOS(os)) return css(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose([""])));
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      return css(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n        @media (min-width: ", ") {\n          ", "\n        }\n      "])), breakpoints[breakpoint], style && css.apply(void 0, [style].concat(rest)));
    };
  };
  return {
    lessThan: lessThan,
    greaterThan: greaterThan
  };
}

var spacing = {
  none: '0rem',
  small: '1rem',
  medium: '2rem',
  large: '4.5rem',
  xlarge: '8rem',
  xxlarge: '12rem'
};
var gutter = {
  small: '1rem',
  "default": '2rem'
};

var _templateObject$x, _templateObject2$v, _templateObject3$n;
var breakpoints = {
  mobile: '450px',
  tablet: '768px',
  desktop: '1024px',
  desktop_large: '1440px'
};
var media = /*#__PURE__*/generateMedia(breakpoints);
function gap(gapSize) {
  return css(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n    gap: ", ";\n\n    /**\n     * Identifies Safari browser, which doesn't support flex-gap.\n     * @see {https://caniuse.com/mdn-css_properties_aspect-ratio}\n     */\n    @supports not (aspect-ratio: 1 / 1) {\n      & > * {\n        margin: ", " ", ";\n      }\n    }\n  "])), gapSize, math(gapSize + " / 2"), math(gapSize + " / 2"));
}
var Grid = {
  Wrapper: /*#__PURE__*/styled.div(_templateObject2$v || (_templateObject2$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: ", ";\n    padding-right: ", ";\n    width: 100%;\n    max-width: ", ";\n\n    ", "\n  "])), gutter["default"], gutter["default"], breakpoints.tablet, /*#__PURE__*/media.greaterThan('tablet')(_templateObject3$n || (_templateObject3$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      max-width: ", ";\n    "])), breakpoints.desktop))
};

var layers = {
  under: -1,
  "default": 0,
  above: 1,
  menu: 10,
  modal: 20,
  alert: 100
};

var opacity = {
  extreme: 0.15,
  hard: 0.35,
  medium: 0.65,
  light: 0.85
};

var radius = {
  small: '1rem',
  medium: '2rem',
  large: '4rem'
};

var _templateObject$w;
var scrollBar = /*#__PURE__*/css(_templateObject$w || (_templateObject$w = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ::-webkit-scrollbar {\n    width: 0.4rem;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: ", ";\n  }\n"])), colors.secondary, radius.medium);

var _templateObject$v;
var shadows = {
  "default": '0.1rem 1rem 1.8rem 0 rgba(0, 0, 0, 0.15)',
  soft: '0 0.3rem 0.8rem rgba(0, 0, 0, 0.10)',
  /**
   * TODO: Check if this new token is necessary
   */
  level1: '0 0.6rem 0.8rem rgba(0, 0, 0, 0.15)',
  inner: /*#__PURE__*/css(_templateObject$v || (_templateObject$v = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: relative;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(\n        to bottom,\n        rgba(0, 0, 0, 0) 0%,\n        rgba(0, 0, 0, 0.35) 25%,\n        rgba(0, 0, 0, 0.65) 50%,\n        rgba(0, 0, 0, 0.85) 75%,\n        rgba(0, 0, 0, 1) 100%\n      );\n    }\n  "])))
};

var transitions = {
  easeInAndOutBack: '0.3s cubic-bezier(0.5, -0.1, 0.3, 1.2)'
};

var _templateObject$u, _templateObject2$u, _templateObject3$m, _templateObject4$l, _templateObject5$j, _templateObject6$h, _templateObject7$g, _templateObject8$f;
var font_family = {
  creo: "'Creo', sans-serif",
  quicksand: "'Quicksand', sans-serif"
};
var typography = {
  body_text_1: /*#__PURE__*/css(_templateObject$u || (_templateObject$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.4rem;\n    font-weight: 300;\n    line-height: 1.4;\n  "])), font_family.creo),
  body_text_2: /*#__PURE__*/css(_templateObject2$u || (_templateObject2$u = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.4rem;\n    font-weight: 300;\n    line-height: 1.1;\n  "])), font_family.creo),
  body_text_3: /*#__PURE__*/css(_templateObject3$m || (_templateObject3$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1rem;\n    font-weight: 600;\n    line-height: 1.1;\n  "])), font_family.creo),
  heading_display: /*#__PURE__*/css(_templateObject4$l || (_templateObject4$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 3.6rem;\n    font-weight: 700;\n    line-height: 1.4;\n  "])), font_family.quicksand),
  heading_1: /*#__PURE__*/css(_templateObject5$j || (_templateObject5$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2.4rem;\n    font-weight: 700;\n    line-height: 1.4;\n  "])), font_family.quicksand),
  heading_2: /*#__PURE__*/css(_templateObject6$h || (_templateObject6$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2.2rem;\n    font-weight: 700;\n    line-height: 1.4;\n  "])), font_family.creo),
  heading_3: /*#__PURE__*/css(_templateObject7$g || (_templateObject7$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 1.4;\n  "])), font_family.quicksand),
  heading_4: /*#__PURE__*/css(_templateObject8$f || (_templateObject8$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.6rem;\n    font-weight: 700;\n    line-height: 1.2;\n  "])), font_family.creo)
};

var _templateObject$t, _templateObject2$t;
var desktop_small_height_mixin = {
  width: breakpoints.desktop,
  height: '750px'
};
var isDesktopSmallHeight = function isDesktopSmallHeight(os) {
  return function (style) {
    if (!checkOS(os)) return css(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose([""])));
    var width = desktop_small_height_mixin.width,
      height = desktop_small_height_mixin.height;
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return css(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n      @media (min-width: ", ") and (max-height: ", ") {\n        ", "\n      }\n    "])), width, height, style && css.apply(void 0, [style].concat(rest)));
  };
};

var _templateObject$s, _templateObject2$s, _templateObject3$l, _templateObject4$k, _templateObject5$i, _templateObject6$g, _templateObject7$f, _templateObject8$e, _templateObject9$d, _templateObject10$a, _templateObject11$a, _templateObject12$a, _templateObject13$9, _templateObject14$7, _templateObject15$6, _templateObject16$6, _templateObject17$5, _templateObject18$6;
var font_weight = {
  light: 300,
  medium: 500,
  bold: 600,
  black: 900
};
var line_height = {
  heading: {
    "default": 1.4,
    small: 1.2,
    none: 1
  },
  body_text: {
    "default": 1.6,
    small: 1.4,
    none: 1
  }
};
var paragraph_spacing = {
  heading: 'small',
  body_text: 'medium'
};
var new_typography = {
  body_text_1: /*#__PURE__*/css(_templateObject$s || (_templateObject$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.6rem;\n    font-weight: ", ";\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.creo, font_weight.light, line_height.body_text["default"], spacing[paragraph_spacing.body_text], /*#__PURE__*/media.greaterThan('tablet')(_templateObject2$s || (_templateObject2$s = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 2rem;\n    "])))),
  body_text_2: /*#__PURE__*/css(_templateObject3$l || (_templateObject3$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.4rem;\n    font-weight: ", ";\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.creo, font_weight.light, line_height.body_text["default"], spacing[paragraph_spacing.body_text], /*#__PURE__*/media.greaterThan('tablet')(_templateObject4$k || (_templateObject4$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 1.8rem;\n\n      ", "\n    "])), /*#__PURE__*/isDesktopSmallHeight()(_templateObject5$i || (_templateObject5$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n        font-size: 1.6rem;\n      "]))))),
  body_text_3: /*#__PURE__*/css(_templateObject6$g || (_templateObject6$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.2rem;\n    font-weight: ", ";\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.creo, font_weight.light, line_height.body_text["default"], spacing[paragraph_spacing.body_text], /*#__PURE__*/media.greaterThan('tablet')(_templateObject7$f || (_templateObject7$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 1.6rem;\n    "])))),
  heading_1: /*#__PURE__*/css(_templateObject8$e || (_templateObject8$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2.8rem;\n    font-weight: 700;\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.quicksand, line_height.heading["default"], spacing[paragraph_spacing.heading], /*#__PURE__*/media.greaterThan('tablet')(_templateObject9$d || (_templateObject9$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 3.6rem;\n\n      ", "\n    "])), /*#__PURE__*/isDesktopSmallHeight()(_templateObject10$a || (_templateObject10$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n        font-size: 3rem;\n      "]))))),
  heading_2: /*#__PURE__*/css(_templateObject11$a || (_templateObject11$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2.4rem;\n    font-weight: 700;\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.quicksand, line_height.heading["default"], spacing[paragraph_spacing.heading], /*#__PURE__*/media.greaterThan('tablet')(_templateObject12$a || (_templateObject12$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 3rem;\n    "])))),
  heading_3: /*#__PURE__*/css(_templateObject13$9 || (_templateObject13$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.quicksand, line_height.heading["default"], spacing[paragraph_spacing.heading], /*#__PURE__*/media.greaterThan('tablet')(_templateObject14$7 || (_templateObject14$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 2.6rem;\n    "])))),
  heading_4: /*#__PURE__*/css(_templateObject15$6 || (_templateObject15$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.6rem;\n    font-weight: 700;\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.quicksand, line_height.heading["default"], spacing[paragraph_spacing.heading], /*#__PURE__*/media.greaterThan('tablet')(_templateObject16$6 || (_templateObject16$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 2.2rem;\n    "])))),
  heading_5: /*#__PURE__*/css(_templateObject17$5 || (_templateObject17$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-size: 1.4rem;\n    font-weight: 700;\n    line-height: ", ";\n    margin-bottom: ", ";\n\n    ", "\n  "])), font_family.quicksand, line_height.heading["default"], spacing[paragraph_spacing.heading], /*#__PURE__*/media.greaterThan('tablet')(_templateObject18$6 || (_templateObject18$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      font-size: 1.8rem;\n    "]))))
};

var _templateObject$r, _templateObject2$r;
var mobile_small_mixin = {
  width: /*#__PURE__*/math(breakpoints.tablet + " - 1px"),
  height: '667px'
};
var isMobileSmall = function isMobileSmall(os) {
  return function (style) {
    if (!checkOS(os)) return css(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose([""])));
    var width = mobile_small_mixin.width,
      height = mobile_small_mixin.height;
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return css(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["\n      @media (max-height: ", ") and (max-width: ", ") {\n        ", "\n      }\n    "])), height, width, style && css.apply(void 0, [style].concat(rest)));
  };
};

var _templateObject$q, _templateObject2$q;
var mobile_large_mixin = {
  width: /*#__PURE__*/math(breakpoints.tablet + " - 1px"),
  height: '812px'
};
var isMobileLarge = function isMobileLarge(os) {
  return function (style) {
    if (!checkOS(os)) return css(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose([""])));
    var width = mobile_large_mixin.width,
      height = mobile_large_mixin.height;
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return css(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n      @media (min-height: ", ") and (max-width: ", ") {\n        ", "\n      }\n    "])), height, width, style && css.apply(void 0, [style].concat(rest)));
  };
};

var _templateObject$p, _templateObject2$p;
var desktop_small_mixin = {
  width: breakpoints.desktop,
  height: '768px'
};
var isDesktopSmall = function isDesktopSmall(os) {
  return function (style) {
    if (!checkOS(os)) return css(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose([""])));
    var width = desktop_small_mixin.width,
      height = desktop_small_mixin.height;
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n      @media (min-width: ", ") and (max-height: ", ") {\n        ", "\n      }\n    "])), width, height, style && css.apply(void 0, [style].concat(rest)));
  };
};

var _templateObject$o, _templateObject2$o;
var mobile_keyboard_open_mixin = {
  width: /*#__PURE__*/math(breakpoints.tablet + " - 1px"),
  height: '460px'
};
var isMobileKeyboardOpen = function isMobileKeyboardOpen(os) {
  return function (style) {
    if (!checkOS(os)) return css(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose([""])));
    var width = mobile_keyboard_open_mixin.width,
      height = mobile_keyboard_open_mixin.height;
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return css(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n      @media (max-height: ", ") and (max-width: ", ") {\n        ", "\n      }\n    "])), height, width, style && css.apply(void 0, [style].concat(rest)));
  };
};

var _templateObject$n, _templateObject2$n;
/**
 * Create common resets to be exported by the lib and
 * internally into Storybook.
 */
var CommonStyles = /*#__PURE__*/css(_templateObject$n || (_templateObject$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /**\n  * Quicksand Bold\n  */\n  @font-face {\n    font-family: 'Quicksand';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/quicksand/v24/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv58a-wg.woff2)\n      format('woff2');\n  }\n\n  /**\n   * Creo Light\n   */\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 300;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-light.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 300;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-light-italic.woff2')\n      format('woff2');\n  }\n\n  /**\n   * Creo Medium\n   */\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 400;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-medium.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 400;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-medium-italic.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 500;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-medium.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 500;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-medium-italic.woff2')\n      format('woff2');\n  }\n\n  /**\n   * Creo Semibold\n   */\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 600;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-semibold.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 600;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-semibold-italic.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 700;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-semibold.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 700;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-semibold-italic.woff2')\n      format('woff2');\n  }\n\n  /**\n   * Creo Black\n   */\n  @font-face {\n    font-family: 'Creo';\n    font-style: normal;\n    font-weight: 900;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-black.woff2')\n      format('woff2');\n  }\n\n  @font-face {\n    font-family: 'Creo';\n    font-style: italic;\n    font-weight: 900;\n    font-display: swap;\n    src: url('https://dw2wqdtrqluy8.cloudfront.net/creo-black-italic.woff2')\n      format('woff2');\n  }\n\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: 62.5%;\n  }\n\n  body {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    margin: 0;\n  }\n"])));
var CSSReset = /*#__PURE__*/createGlobalStyle(_templateObject2$n || (_templateObject2$n = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  body {\n    font-family: ", ";\n  }\n"])), CommonStyles, font_family.creo);

var _templateObject$m, _templateObject2$m, _templateObject3$k, _templateObject4$j, _templateObject5$h, _templateObject6$f, _templateObject7$e, _templateObject8$d, _templateObject9$c, _templateObject10$9, _templateObject11$9, _templateObject12$9, _templateObject13$8, _templateObject14$6, _templateObject15$5, _templateObject16$5, _templateObject17$4, _templateObject18$5, _templateObject19$5, _templateObject20$5, _templateObject21$5, _templateObject22$5, _templateObject23$3, _templateObject24$3, _templateObject25$3, _templateObject26$3, _templateObject27$3, _templateObject28$2, _templateObject29$2, _templateObject30$1, _templateObject31$1, _templateObject32$1, _templateObject33$1, _templateObject34$1, _templateObject35$1, _templateObject36$1, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107, _templateObject108, _templateObject109, _templateObject110;
var Clock = /*#__PURE__*/styled(Schedule)(_templateObject$m || (_templateObject$m = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 18 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 18 : _ref$width;
  return css(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Facebook = /*#__PURE__*/styled(FacebookWithCircle)(_templateObject3$k || (_templateObject3$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 18 : _ref2$height,
    _ref2$width = _ref2.width,
    width = _ref2$width === void 0 ? 18 : _ref2$width;
  return css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Instagram = /*#__PURE__*/styled(InstagramWithCircle)(_templateObject5$h || (_templateObject5$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'primary' : _ref3$color,
    _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? 18 : _ref3$height,
    _ref3$width = _ref3.width,
    width = _ref3$width === void 0 ? 18 : _ref3$width;
  return css(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Linkedin = /*#__PURE__*/styled(LinkedinWithCircle)(_templateObject7$e || (_templateObject7$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'primary' : _ref4$color,
    _ref4$height = _ref4.height,
    height = _ref4$height === void 0 ? 18 : _ref4$height,
    _ref4$width = _ref4.width,
    width = _ref4$width === void 0 ? 18 : _ref4$width;
  return css(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Mail = /*#__PURE__*/styled(MailWithCircle)(_templateObject9$c || (_templateObject9$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref5) {
  var _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? 'primary' : _ref5$color,
    _ref5$height = _ref5.height,
    height = _ref5$height === void 0 ? 18 : _ref5$height,
    _ref5$width = _ref5.width,
    width = _ref5$width === void 0 ? 18 : _ref5$width;
  return css(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Search = /*#__PURE__*/styled(MagnifyingGlass)(_templateObject11$9 || (_templateObject11$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref6) {
  var _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? 'primary' : _ref6$color,
    _ref6$height = _ref6.height,
    height = _ref6$height === void 0 ? 18 : _ref6$height,
    _ref6$width = _ref6.width,
    width = _ref6$width === void 0 ? 18 : _ref6$width;
  return css(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var User = /*#__PURE__*/styled(User$1)(_templateObject13$8 || (_templateObject13$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref7) {
  var _ref7$color = _ref7.color,
    color = _ref7$color === void 0 ? 'primary' : _ref7$color,
    _ref7$height = _ref7.height,
    height = _ref7$height === void 0 ? 18 : _ref7$height,
    _ref7$width = _ref7.width,
    width = _ref7$width === void 0 ? 18 : _ref7$width;
  return css(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Users = /*#__PURE__*/styled(Users$1)(_templateObject15$5 || (_templateObject15$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref8) {
  var _ref8$color = _ref8.color,
    color = _ref8$color === void 0 ? 'primary' : _ref8$color,
    _ref8$height = _ref8.height,
    height = _ref8$height === void 0 ? 18 : _ref8$height,
    _ref8$width = _ref8.width,
    width = _ref8$width === void 0 ? 18 : _ref8$width;
  return css(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Whatsapp = /*#__PURE__*/styled(Whatsapp$1)(_templateObject17$4 || (_templateObject17$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref9) {
  var _ref9$color = _ref9.color,
    color = _ref9$color === void 0 ? 'primary' : _ref9$color,
    _ref9$height = _ref9.height,
    height = _ref9$height === void 0 ? 18 : _ref9$height,
    _ref9$width = _ref9.width,
    width = _ref9$width === void 0 ? 18 : _ref9$width;
  return css(_templateObject18$5 || (_templateObject18$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Menu = /*#__PURE__*/styled(MenuAlt1)(_templateObject19$5 || (_templateObject19$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref10) {
  var _ref10$color = _ref10.color,
    color = _ref10$color === void 0 ? 'primary' : _ref10$color,
    _ref10$height = _ref10.height,
    height = _ref10$height === void 0 ? 18 : _ref10$height,
    _ref10$width = _ref10.width,
    width = _ref10$width === void 0 ? 18 : _ref10$width;
  return css(_templateObject20$5 || (_templateObject20$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Check = /*#__PURE__*/styled(SelectMultiple)(_templateObject21$5 || (_templateObject21$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref11) {
  var _ref11$color = _ref11.color,
    color = _ref11$color === void 0 ? 'primary' : _ref11$color,
    _ref11$height = _ref11.height,
    height = _ref11$height === void 0 ? 18 : _ref11$height,
    _ref11$width = _ref11.width,
    width = _ref11$width === void 0 ? 18 : _ref11$width;
  return css(_templateObject22$5 || (_templateObject22$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Secure = /*#__PURE__*/styled(SecurePayment)(_templateObject23$3 || (_templateObject23$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref12) {
  var _ref12$color = _ref12.color,
    color = _ref12$color === void 0 ? 'primary' : _ref12$color,
    _ref12$height = _ref12.height,
    height = _ref12$height === void 0 ? 18 : _ref12$height,
    _ref12$width = _ref12.width,
    width = _ref12$width === void 0 ? 18 : _ref12$width;
  return css(_templateObject24$3 || (_templateObject24$3 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Loading = /*#__PURE__*/styled(HourglassSplit)(_templateObject25$3 || (_templateObject25$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref13) {
  var _ref13$color = _ref13.color,
    color = _ref13$color === void 0 ? 'primary' : _ref13$color,
    _ref13$height = _ref13.height,
    height = _ref13$height === void 0 ? 18 : _ref13$height,
    _ref13$width = _ref13.width,
    width = _ref13$width === void 0 ? 18 : _ref13$width;
  return css(_templateObject26$3 || (_templateObject26$3 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var CalendarCheck = /*#__PURE__*/styled(CalendarCheckFill)(_templateObject27$3 || (_templateObject27$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref14) {
  var _ref14$color = _ref14.color,
    color = _ref14$color === void 0 ? 'primary' : _ref14$color,
    _ref14$height = _ref14.height,
    height = _ref14$height === void 0 ? 18 : _ref14$height,
    _ref14$width = _ref14.width,
    width = _ref14$width === void 0 ? 18 : _ref14$width;
  return css(_templateObject28$2 || (_templateObject28$2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Time = /*#__PURE__*/styled(RestTime)(_templateObject29$2 || (_templateObject29$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref15) {
  var _ref15$color = _ref15.color,
    color = _ref15$color === void 0 ? 'primary' : _ref15$color,
    _ref15$height = _ref15.height,
    height = _ref15$height === void 0 ? 18 : _ref15$height,
    _ref15$width = _ref15.width,
    width = _ref15$width === void 0 ? 18 : _ref15$width;
  return css(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Location = /*#__PURE__*/styled(LocationMarker)(_templateObject31$1 || (_templateObject31$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref16) {
  var _ref16$color = _ref16.color,
    color = _ref16$color === void 0 ? 'primary' : _ref16$color,
    _ref16$height = _ref16.height,
    height = _ref16$height === void 0 ? 18 : _ref16$height,
    _ref16$width = _ref16.width,
    width = _ref16$width === void 0 ? 18 : _ref16$width;
  return css(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Edit = /*#__PURE__*/styled(Edit$1)(_templateObject33$1 || (_templateObject33$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref17) {
  var _ref17$color = _ref17.color,
    color = _ref17$color === void 0 ? 'primary' : _ref17$color,
    _ref17$height = _ref17.height,
    height = _ref17$height === void 0 ? 18 : _ref17$height,
    _ref17$width = _ref17.width,
    width = _ref17$width === void 0 ? 18 : _ref17$width;
  return css(_templateObject34$1 || (_templateObject34$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var CloseCircle = /*#__PURE__*/styled(CloseCircle$1)(_templateObject35$1 || (_templateObject35$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref18) {
  var _ref18$color = _ref18.color,
    color = _ref18$color === void 0 ? 'primary' : _ref18$color,
    _ref18$height = _ref18.height,
    height = _ref18$height === void 0 ? 18 : _ref18$height,
    _ref18$width = _ref18.width,
    width = _ref18$width === void 0 ? 18 : _ref18$width;
  return css(_templateObject36$1 || (_templateObject36$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var PlusCircle = /*#__PURE__*/styled(PlusCircle$1)(_templateObject37 || (_templateObject37 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref19) {
  var _ref19$color = _ref19.color,
    color = _ref19$color === void 0 ? 'primary' : _ref19$color,
    _ref19$height = _ref19.height,
    height = _ref19$height === void 0 ? 18 : _ref19$height,
    _ref19$width = _ref19.width,
    width = _ref19$width === void 0 ? 18 : _ref19$width;
  return css(_templateObject38 || (_templateObject38 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var MinusCircle = /*#__PURE__*/styled(MinusCircle$1)(_templateObject39 || (_templateObject39 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref20) {
  var _ref20$color = _ref20.color,
    color = _ref20$color === void 0 ? 'primary' : _ref20$color,
    _ref20$height = _ref20.height,
    height = _ref20$height === void 0 ? 18 : _ref20$height,
    _ref20$width = _ref20.width,
    width = _ref20$width === void 0 ? 18 : _ref20$width;
  return css(_templateObject40 || (_templateObject40 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var InfoCircle = /*#__PURE__*/styled(InfoCircleFill)(_templateObject41 || (_templateObject41 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref21) {
  var _ref21$color = _ref21.color,
    color = _ref21$color === void 0 ? 'primary' : _ref21$color,
    _ref21$height = _ref21.height,
    height = _ref21$height === void 0 ? 18 : _ref21$height,
    _ref21$width = _ref21.width,
    width = _ref21$width === void 0 ? 18 : _ref21$width;
  return css(_templateObject42 || (_templateObject42 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var QuestionCircle = /*#__PURE__*/styled(QuestionCircleFill)(_templateObject43 || (_templateObject43 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref22) {
  var _ref22$color = _ref22.color,
    color = _ref22$color === void 0 ? 'primary' : _ref22$color,
    _ref22$height = _ref22.height,
    height = _ref22$height === void 0 ? 18 : _ref22$height,
    _ref22$width = _ref22.width,
    width = _ref22$width === void 0 ? 18 : _ref22$width;
  return css(_templateObject44 || (_templateObject44 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Timer = /*#__PURE__*/styled(Timer$1)(_templateObject45 || (_templateObject45 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref23) {
  var _ref23$color = _ref23.color,
    color = _ref23$color === void 0 ? 'primary' : _ref23$color,
    _ref23$height = _ref23.height,
    height = _ref23$height === void 0 ? 18 : _ref23$height,
    _ref23$width = _ref23.width,
    width = _ref23$width === void 0 ? 18 : _ref23$width;
  return css(_templateObject46 || (_templateObject46 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var ArrowDown = /*#__PURE__*/styled(ArrowIosDownward)(_templateObject47 || (_templateObject47 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref24) {
  var _ref24$color = _ref24.color,
    color = _ref24$color === void 0 ? 'primary' : _ref24$color,
    _ref24$height = _ref24.height,
    height = _ref24$height === void 0 ? 18 : _ref24$height,
    _ref24$width = _ref24.width,
    width = _ref24$width === void 0 ? 18 : _ref24$width;
  return css(_templateObject48 || (_templateObject48 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Chat = /*#__PURE__*/styled(ChatDotsFill)(_templateObject49 || (_templateObject49 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref25) {
  var _ref25$color = _ref25.color,
    color = _ref25$color === void 0 ? 'primary' : _ref25$color,
    _ref25$height = _ref25.height,
    height = _ref25$height === void 0 ? 18 : _ref25$height,
    _ref25$width = _ref25.width,
    width = _ref25$width === void 0 ? 18 : _ref25$width;
  return css(_templateObject50 || (_templateObject50 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var House = /*#__PURE__*/styled(HouseLaptop)(_templateObject51 || (_templateObject51 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref26) {
  var _ref26$color = _ref26.color,
    color = _ref26$color === void 0 ? 'primary' : _ref26$color,
    _ref26$height = _ref26.height,
    height = _ref26$height === void 0 ? 18 : _ref26$height,
    _ref26$width = _ref26.width,
    width = _ref26$width === void 0 ? 18 : _ref26$width;
  return css(_templateObject52 || (_templateObject52 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var HouseAddress = /*#__PURE__*/styled(MapsHomeWork)(_templateObject53 || (_templateObject53 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref27) {
  var _ref27$color = _ref27.color,
    color = _ref27$color === void 0 ? 'primary' : _ref27$color,
    _ref27$height = _ref27.height,
    height = _ref27$height === void 0 ? 18 : _ref27$height,
    _ref27$width = _ref27.width,
    width = _ref27$width === void 0 ? 18 : _ref27$width;
  return css(_templateObject54 || (_templateObject54 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Virus = /*#__PURE__*/styled(ShieldVirus)(_templateObject55 || (_templateObject55 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref28) {
  var _ref28$color = _ref28.color,
    color = _ref28$color === void 0 ? 'primary' : _ref28$color,
    _ref28$height = _ref28.height,
    height = _ref28$height === void 0 ? 18 : _ref28$height,
    _ref28$width = _ref28.width,
    width = _ref28$width === void 0 ? 18 : _ref28$width;
  return css(_templateObject56 || (_templateObject56 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Blood = /*#__PURE__*/styled(Bloodtype)(_templateObject57 || (_templateObject57 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref29) {
  var _ref29$color = _ref29.color,
    color = _ref29$color === void 0 ? 'primary' : _ref29$color,
    _ref29$height = _ref29.height,
    height = _ref29$height === void 0 ? 18 : _ref29$height,
    _ref29$width = _ref29.width,
    width = _ref29$width === void 0 ? 18 : _ref29$width;
  return css(_templateObject58 || (_templateObject58 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Xray = /*#__PURE__*/styled(Xray$1)(_templateObject59 || (_templateObject59 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref30) {
  var _ref30$color = _ref30.color,
    color = _ref30$color === void 0 ? 'primary' : _ref30$color,
    _ref30$height = _ref30.height,
    height = _ref30$height === void 0 ? 18 : _ref30$height,
    _ref30$width = _ref30.width,
    width = _ref30$width === void 0 ? 18 : _ref30$width;
  return css(_templateObject60 || (_templateObject60 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Doctor = /*#__PURE__*/styled(Doctor$1)(_templateObject61 || (_templateObject61 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref31) {
  var _ref31$color = _ref31.color,
    color = _ref31$color === void 0 ? 'primary' : _ref31$color,
    _ref31$height = _ref31.height,
    height = _ref31$height === void 0 ? 18 : _ref31$height,
    _ref31$width = _ref31.width,
    width = _ref31$width === void 0 ? 18 : _ref31$width;
  return css(_templateObject62 || (_templateObject62 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Nurse = /*#__PURE__*/styled(UserNurse)(_templateObject63 || (_templateObject63 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref32) {
  var _ref32$color = _ref32.color,
    color = _ref32$color === void 0 ? 'primary' : _ref32$color,
    _ref32$height = _ref32.height,
    height = _ref32$height === void 0 ? 18 : _ref32$height,
    _ref32$width = _ref32.width,
    width = _ref32$width === void 0 ? 18 : _ref32$width;
  return css(_templateObject64 || (_templateObject64 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Face = /*#__PURE__*/styled(Face$1)(_templateObject65 || (_templateObject65 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref33) {
  var _ref33$color = _ref33.color,
    color = _ref33$color === void 0 ? 'primary' : _ref33$color,
    _ref33$height = _ref33.height,
    height = _ref33$height === void 0 ? 18 : _ref33$height,
    _ref33$width = _ref33.width,
    width = _ref33$width === void 0 ? 18 : _ref33$width;
  return css(_templateObject66 || (_templateObject66 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Cloud = /*#__PURE__*/styled(CloudUpload)(_templateObject67 || (_templateObject67 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref34) {
  var _ref34$color = _ref34.color,
    color = _ref34$color === void 0 ? 'primary' : _ref34$color,
    _ref34$height = _ref34.height,
    height = _ref34$height === void 0 ? 18 : _ref34$height,
    _ref34$width = _ref34.width,
    width = _ref34$width === void 0 ? 18 : _ref34$width;
  return css(_templateObject68 || (_templateObject68 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Delete = /*#__PURE__*/styled(DeleteDismiss)(_templateObject69 || (_templateObject69 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref35) {
  var _ref35$color = _ref35.color,
    color = _ref35$color === void 0 ? 'primary' : _ref35$color,
    _ref35$height = _ref35.height,
    height = _ref35$height === void 0 ? 18 : _ref35$height,
    _ref35$width = _ref35.width,
    width = _ref35$width === void 0 ? 18 : _ref35$width;
  return css(_templateObject70 || (_templateObject70 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Close = /*#__PURE__*/styled(CloseOutline)(_templateObject71 || (_templateObject71 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref36) {
  var _ref36$color = _ref36.color,
    color = _ref36$color === void 0 ? 'primary' : _ref36$color,
    _ref36$height = _ref36.height,
    height = _ref36$height === void 0 ? 18 : _ref36$height,
    _ref36$width = _ref36.width,
    width = _ref36$width === void 0 ? 18 : _ref36$width;
  return css(_templateObject72 || (_templateObject72 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var CloseCircleOutline = /*#__PURE__*/styled(CloseCircleOutline$1)(_templateObject73 || (_templateObject73 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref37) {
  var _ref37$color = _ref37.color,
    color = _ref37$color === void 0 ? 'primary' : _ref37$color,
    _ref37$height = _ref37.height,
    height = _ref37$height === void 0 ? 18 : _ref37$height,
    _ref37$width = _ref37.width,
    width = _ref37$width === void 0 ? 18 : _ref37$width;
  return css(_templateObject74 || (_templateObject74 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Telephone = /*#__PURE__*/styled(Telephone$1)(_templateObject75 || (_templateObject75 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref38) {
  var _ref38$color = _ref38.color,
    color = _ref38$color === void 0 ? 'primary' : _ref38$color,
    _ref38$height = _ref38.height,
    height = _ref38$height === void 0 ? 18 : _ref38$height,
    _ref38$width = _ref38.width,
    width = _ref38$width === void 0 ? 18 : _ref38$width;
  return css(_templateObject76 || (_templateObject76 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var HandDraw = /*#__PURE__*/styled(HandDraw$1)(_templateObject77 || (_templateObject77 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref39) {
  var _ref39$color = _ref39.color,
    color = _ref39$color === void 0 ? 'primary' : _ref39$color,
    _ref39$height = _ref39.height,
    height = _ref39$height === void 0 ? 18 : _ref39$height,
    _ref39$width = _ref39.width,
    width = _ref39$width === void 0 ? 18 : _ref39$width;
  return css(_templateObject78 || (_templateObject78 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Password = /*#__PURE__*/styled(Password$1)(_templateObject79 || (_templateObject79 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref40) {
  var _ref40$color = _ref40.color,
    color = _ref40$color === void 0 ? 'primary' : _ref40$color,
    _ref40$height = _ref40.height,
    height = _ref40$height === void 0 ? 18 : _ref40$height,
    _ref40$width = _ref40.width,
    width = _ref40$width === void 0 ? 18 : _ref40$width;
  return css(_templateObject80 || (_templateObject80 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var MailSimple = /*#__PURE__*/styled(Email)(_templateObject81 || (_templateObject81 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref41) {
  var _ref41$color = _ref41.color,
    color = _ref41$color === void 0 ? 'primary' : _ref41$color,
    _ref41$height = _ref41.height,
    height = _ref41$height === void 0 ? 18 : _ref41$height,
    _ref41$width = _ref41.width,
    width = _ref41$width === void 0 ? 18 : _ref41$width;
  return css(_templateObject82 || (_templateObject82 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Send = /*#__PURE__*/styled(SendClock)(_templateObject83 || (_templateObject83 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref42) {
  var _ref42$color = _ref42.color,
    color = _ref42$color === void 0 ? 'primary' : _ref42$color,
    _ref42$height = _ref42.height,
    height = _ref42$height === void 0 ? 18 : _ref42$height,
    _ref42$width = _ref42.width,
    width = _ref42$width === void 0 ? 18 : _ref42$width;
  return css(_templateObject84 || (_templateObject84 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Share = /*#__PURE__*/styled(ShareFill)(_templateObject85 || (_templateObject85 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref43) {
  var _ref43$color = _ref43.color,
    color = _ref43$color === void 0 ? 'primary' : _ref43$color,
    _ref43$height = _ref43.height,
    height = _ref43$height === void 0 ? 18 : _ref43$height,
    _ref43$width = _ref43.width,
    width = _ref43$width === void 0 ? 18 : _ref43$width;
  return css(_templateObject86 || (_templateObject86 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var NotebookQuestion = /*#__PURE__*/styled(NotebookQuestionMark)(_templateObject87 || (_templateObject87 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref44) {
  var _ref44$color = _ref44.color,
    color = _ref44$color === void 0 ? 'primary' : _ref44$color,
    _ref44$height = _ref44.height,
    height = _ref44$height === void 0 ? 18 : _ref44$height,
    _ref44$width = _ref44.width,
    width = _ref44$width === void 0 ? 18 : _ref44$width;
  return css(_templateObject88 || (_templateObject88 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Star = /*#__PURE__*/styled(StarFill)(_templateObject89 || (_templateObject89 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref45) {
  var _ref45$color = _ref45.color,
    color = _ref45$color === void 0 ? 'primary' : _ref45$color,
    _ref45$height = _ref45.height,
    height = _ref45$height === void 0 ? 18 : _ref45$height,
    _ref45$width = _ref45.width,
    width = _ref45$width === void 0 ? 18 : _ref45$width;
  return css(_templateObject90 || (_templateObject90 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var ChatQuestion = /*#__PURE__*/styled(ChatBubblesQuestion)(_templateObject91 || (_templateObject91 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref46) {
  var _ref46$color = _ref46.color,
    color = _ref46$color === void 0 ? 'primary' : _ref46$color,
    _ref46$height = _ref46.height,
    height = _ref46$height === void 0 ? 18 : _ref46$height,
    _ref46$width = _ref46.width,
    width = _ref46$width === void 0 ? 18 : _ref46$width;
  return css(_templateObject92 || (_templateObject92 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var ChatSquareText = /*#__PURE__*/styled(ChatSquareTextFill)(_templateObject93 || (_templateObject93 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref47) {
  var _ref47$color = _ref47.color,
    color = _ref47$color === void 0 ? 'primary' : _ref47$color,
    _ref47$height = _ref47.height,
    height = _ref47$height === void 0 ? 18 : _ref47$height,
    _ref47$width = _ref47.width,
    width = _ref47$width === void 0 ? 18 : _ref47$width;
  return css(_templateObject94 || (_templateObject94 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var ChatPlusOne = /*#__PURE__*/styled(ChatFollowUp)(_templateObject95 || (_templateObject95 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref48) {
  var _ref48$color = _ref48.color,
    color = _ref48$color === void 0 ? 'primary' : _ref48$color,
    _ref48$height = _ref48.height,
    height = _ref48$height === void 0 ? 18 : _ref48$height,
    _ref48$width = _ref48.width,
    width = _ref48$width === void 0 ? 18 : _ref48$width;
  return css(_templateObject96 || (_templateObject96 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var MedicalNote = /*#__PURE__*/styled(NotesMedical)(_templateObject97 || (_templateObject97 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref49) {
  var _ref49$color = _ref49.color,
    color = _ref49$color === void 0 ? 'primary' : _ref49$color,
    _ref49$height = _ref49.height,
    height = _ref49$height === void 0 ? 18 : _ref49$height,
    _ref49$width = _ref49.width,
    width = _ref49$width === void 0 ? 18 : _ref49$width;
  return css(_templateObject98 || (_templateObject98 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var CheckedCheckbox = /*#__PURE__*/styled(CheckboxChecked)(_templateObject99 || (_templateObject99 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref50) {
  var _ref50$color = _ref50.color,
    color = _ref50$color === void 0 ? 'primary' : _ref50$color,
    _ref50$height = _ref50.height,
    height = _ref50$height === void 0 ? 18 : _ref50$height,
    _ref50$width = _ref50.width,
    width = _ref50$width === void 0 ? 18 : _ref50$width;
  return css(_templateObject100 || (_templateObject100 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var MessageError = /*#__PURE__*/styled(MessageAltError)(_templateObject101 || (_templateObject101 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref51) {
  var _ref51$color = _ref51.color,
    color = _ref51$color === void 0 ? 'primary' : _ref51$color,
    _ref51$height = _ref51.height,
    height = _ref51$height === void 0 ? 18 : _ref51$height,
    _ref51$width = _ref51.width,
    width = _ref51$width === void 0 ? 18 : _ref51$width;
  return css(_templateObject102 || (_templateObject102 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var RefreshCircle = /*#__PURE__*/styled(RefreshCircle$1)(_templateObject103 || (_templateObject103 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref52) {
  var _ref52$color = _ref52.color,
    color = _ref52$color === void 0 ? 'primary' : _ref52$color,
    _ref52$height = _ref52.height,
    height = _ref52$height === void 0 ? 18 : _ref52$height,
    _ref52$width = _ref52.width,
    width = _ref52$width === void 0 ? 18 : _ref52$width;
  return css(_templateObject104 || (_templateObject104 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var ThinArrow = /*#__PURE__*/styled(ArrowRight)(_templateObject105 || (_templateObject105 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref53) {
  var _ref53$color = _ref53.color,
    color = _ref53$color === void 0 ? 'primary' : _ref53$color,
    _ref53$height = _ref53.height,
    height = _ref53$height === void 0 ? 18 : _ref53$height,
    _ref53$width = _ref53.width,
    width = _ref53$width === void 0 ? 18 : _ref53$width;
  return css(_templateObject106 || (_templateObject106 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var Warning = /*#__PURE__*/styled(Warning$1)(_templateObject107 || (_templateObject107 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref54) {
  var _ref54$color = _ref54.color,
    color = _ref54$color === void 0 ? 'primary' : _ref54$color,
    _ref54$height = _ref54.height,
    height = _ref54$height === void 0 ? 18 : _ref54$height,
    _ref54$width = _ref54.width,
    width = _ref54$width === void 0 ? 18 : _ref54$width;
  return css(_templateObject108 || (_templateObject108 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var FileEarmarkCheckFill = /*#__PURE__*/styled(FileEarmarkCheckFill$1)(_templateObject109 || (_templateObject109 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref55) {
  var _ref55$color = _ref55.color,
    color = _ref55$color === void 0 ? 'primary' : _ref55$color,
    _ref55$height = _ref55.height,
    height = _ref55$height === void 0 ? 18 : _ref55$height,
    _ref55$width = _ref55.width,
    width = _ref55$width === void 0 ? 18 : _ref55$width;
  return css(_templateObject110 || (_templateObject110 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    height: ", ";\n    width: ", ";\n  "])), colors[color], rem(height, 10), rem(width, 10));
});
var icons = {
  clock: Clock,
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  mail: Mail,
  search: Search,
  user: User,
  users: Users,
  whatsapp: Whatsapp,
  menu: Menu,
  check: Check,
  secure: Secure,
  loading: Loading,
  calendar: CalendarCheck,
  time: Time,
  location: Location,
  edit: Edit,
  closecircle: CloseCircle,
  pluscircle: PlusCircle,
  minuscircle: MinusCircle,
  infocircle: InfoCircle,
  questioncircle: QuestionCircle,
  timer: Timer,
  arrowDown: ArrowDown,
  chat: Chat,
  house: House,
  houseaddress: HouseAddress,
  virus: Virus,
  blood: Blood,
  xray: Xray,
  doctor: Doctor,
  nurse: Nurse,
  face: Face,
  cloud: Cloud,
  "delete": Delete,
  close: Close,
  telephone: Telephone,
  handDraw: HandDraw,
  password: Password,
  mailSimple: MailSimple,
  send: Send,
  share: Share,
  notebookQuestion: NotebookQuestion,
  star: Star,
  chatQuestion: ChatQuestion,
  chatSquareText: ChatSquareText,
  chatPlusOne: ChatPlusOne,
  medicalNote: MedicalNote,
  checkedCheckbox: CheckedCheckbox,
  messageError: MessageError,
  refreshCircle: RefreshCircle,
  thinArrow: ThinArrow,
  warning: Warning
};

var _templateObject$l, _templateObject2$l, _templateObject3$j;
// Returns the variant without the numbering part ("_1", "_2", "_4", ...)
var getBaseVariant = function getBaseVariant(variant) {
  return variant.slice(0, variant.lastIndexOf('_'));
};
var Typography$2 = /*#__PURE__*/styled.p(_templateObject$l || (_templateObject$l = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    textAlign = _ref.textAlign,
    weight = _ref.weight,
    lineHeight = _ref.lineHeight;
  return css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    text-align: ", ";\n    word-break: break-word;\n    margin-top: ", ";\n\n    ", ";\n\n    ", ";\n\n    line-height: ", ";\n\n    margin-bottom: ", ";\n  "])), colors[color], textAlign, spacing[marginTop], variant && new_typography[variant], getBaseVariant(variant) === 'body_text' && css(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n      font-weight: ", ";\n    "])), font_weight[weight]), line_height[getBaseVariant(variant)][lineHeight], marginBottom ? spacing[marginBottom] : spacing[paragraph_spacing[getBaseVariant(variant)]]);
});

var _excluded$b = ["as", "variant", "color", "marginTop", "textAlign", "fontWeight", "lineHeight", "marginBottom", "children"];
// eslint-disable-next-line react/display-name
var NewTypography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body_text_2' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'text__primary' : _ref$color,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'inherit' : _ref$textAlign,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'light' : _ref$fontWeight,
    _ref$lineHeight = _ref.lineHeight,
    lineHeight = _ref$lineHeight === void 0 ? 'default' : _ref$lineHeight,
    marginBottom = _ref.marginBottom,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  return React.createElement(Typography$2, _extends({
    as: as,
    variant: variant,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    textAlign: textAlign,
    weight: fontWeight,
    lineHeight: lineHeight,
    ref: ref
  }, props), children);
});

var _templateObject$k, _templateObject2$k, _templateObject3$i, _templateObject4$i, _templateObject5$g, _templateObject6$e, _templateObject7$d, _templateObject8$c, _templateObject9$b, _templateObject10$8, _templateObject11$8, _templateObject12$8;
var Title = /*#__PURE__*/styled.p(_templateObject$k || (_templateObject$k = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: left;\n"])), colors.dark);
var variantModifier = {
  "default": function _default() {
    return css(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n\n    ", " {\n      ", ";\n      margin-bottom: 0;\n    }\n  "])), colors.neutral_extra_light, Title, new_typography.body_text_2);
  },
  outline: function outline() {
    return css(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border: ", " solid ", ";\n\n    ", " {\n      ", ";\n      margin-bottom: 0;\n    }\n  "])), colors.light, borderWidths.thin, colors.dark, Title, new_typography.heading_5);
  }
};
var Container = /*#__PURE__*/styled.div(_templateObject4$i || (_templateObject4$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  border-radius: ", ";\n  background-color: ", ";\n  margin-top: ", ";\n\n  ", "\n"])), radius.medium, colors.neutral_light, function (_ref) {
  var marginTop = _ref.marginTop;
  return spacing[marginTop != null ? marginTop : 'medium'];
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant && variantModifier[variant];
});
var AccordionHeader$1 = /*#__PURE__*/styled.button(_templateObject5$g || (_templateObject5$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border: none;\n  width: 100%;\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: ", ";\n  cursor: pointer;\n  background-color: transparent;\n"])), radius.medium, spacing.medium);
var AccordionBody$1 = /*#__PURE__*/styled.div(_templateObject6$e || (_templateObject6$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var active = _ref3.active,
    height = _ref3.height;
  return css(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n      border-radius: ", ";\n      padding: 0 ", ";\n      overflow: hidden;\n      max-height: ", ";\n      transition: all 0.3s ease-out;\n\n      ", "\n    "])), radius.medium, spacing.medium, height, active && css(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n        transition-timing-function: ease-in;\n        border-radius: 0 0 ", " ", ";\n        padding-bottom: ", ";\n        overflow-y: hidden;\n      "])), radius.medium, radius.medium, spacing.medium));
});
var TextContainer = /*#__PURE__*/styled.div(_templateObject9$b || (_templateObject9$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n\n  ", "\n"])), function (_ref4) {
  var active = _ref4.active;
  return active && css(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n      padding: 0 ", " 0 0;\n    "])), spacing.medium);
});
var NumberIcon = /*#__PURE__*/styled.div(_templateObject11$8 || (_templateObject11$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.4rem;\n  height: 2.4rem;\n  margin: 0 ", " 0 0;\n  background-color: ", ";\n  padding: 0.5rem;\n"])), spacing.small, colors.light);
var IconContainer = /*#__PURE__*/styled.div(_templateObject12$8 || (_templateObject12$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  transform: ", ";\n  transition: ease-in-out 0.2s;\n"])), function (_ref5) {
  var toBeRotated = _ref5.toBeRotated;
  return toBeRotated ? 'rotate(180deg)' : 'rotate(0deg)';
});

var Accordion = function Accordion(_ref) {
  var index = _ref.index,
    title = _ref.title,
    body = _ref.body,
    marginTop = _ref.marginTop,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var _useState = useState(false),
    active = _useState[0],
    setActive = _useState[1];
  var _useState2 = useState('0px'),
    height = _useState2[0],
    setHeight = _useState2[1];
  var content = useRef(null);
  function toggleAccordion() {
    var _content$current, _content$current2;
    setActive(function (prevState) {
      return !prevState;
    });
    content && setHeight(active ? '0' : ((content == null || (_content$current = content.current) == null ? void 0 : _content$current.scrollHeight) && (content == null || (_content$current2 = content.current) == null ? void 0 : _content$current2.scrollHeight) + 20) + "px");
  }
  //TODO: Better way of display the header content with a nice contrast with the background color
  return React.createElement(Container, {
    variant: variant,
    marginTop: marginTop
  }, React.createElement(AccordionHeader$1, {
    onClick: toggleAccordion
  }, React.createElement(TextContainer, null, index && React.createElement(NumberIcon, null, React.createElement(NewTypography, {
    marginBottom: "none",
    variant: "heading_4"
  }, index)), React.createElement(Title, null, title)), React.createElement(IconContainer, {
    toBeRotated: active
  }, React.createElement(ArrowDown, {
    color: "dark"
  }))), React.createElement(AccordionBody$1, {
    ref: content,
    active: active,
    height: height
  }, body));
};

var _templateObject$j, _templateObject2$j, _templateObject3$h, _templateObject4$h, _templateObject5$f, _templateObject6$d, _templateObject7$c, _templateObject8$b, _templateObject9$a;
var Wrapper$9 = /*#__PURE__*/styled.div(_templateObject$j || (_templateObject$j = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'neutral_light' : _ref$variant;
  return css(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    border-radius: ", ";\n  "])), colors[variant], radius.small);
});
var AccordionHeader = /*#__PURE__*/styled.div(_templateObject3$h || (_templateObject3$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var _ref2$showControls = _ref2.showControls,
    showControls = _ref2$showControls === void 0 ? true : _ref2$showControls;
  return css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n    cursor: pointer;\n    position: relative;\n\n    ", "\n  "])), !!showControls && css(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n      padding-right: calc((", " * 2) + 24px);\n    "])), gutter.small));
});
var AccordionBody = /*#__PURE__*/styled.div(_templateObject6$d || (_templateObject6$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var open = _ref3.open;
  return css(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n    transition: all 0.3s ease-in-out;\n    overflow: hidden;\n    max-height: 0;\n    opacity: 0;\n\n    ", "\n  "])), open && css(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n      /**\n       * This max-height is needed to proper transition the open/close animation.\n       */\n      max-height: 250rem;\n      padding-top: ", ";\n      padding-bottom: ", ";\n      opacity: 1;\n    "])), gutter["default"], gutter["default"]));
});
var ToggleButton = /*#__PURE__*/styled.button(_templateObject9$a || (_templateObject9$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  right: ", ";\n  top: ", ";\n"])), gutter.small, gutter.small);

var Header$3 = function Header(_ref) {
  var children = _ref.children,
    open = _ref.open,
    _ref$showControls = _ref.showControls,
    showControls = _ref$showControls === void 0 ? true : _ref$showControls,
    onToggle = _ref.onToggle;
  return React.createElement(AccordionHeader, {
    onClick: onToggle,
    showControls: showControls
  }, showControls && React.createElement(ToggleButton, {
    "aria-label": open ? 'Scopri di più' : 'Vedi meno'
  }, open ? React.createElement(MinusCircle, {
    width: 24,
    height: 24,
    color: "dark"
  }) : React.createElement(PlusCircle, {
    width: 24,
    height: 24,
    color: "dark"
  })), children);
};
var Body$1 = function Body(_ref2) {
  var children = _ref2.children,
    open = _ref2.open;
  return React.createElement(AccordionBody, {
    open: open,
    "aria-hidden": !open
  }, children);
};
var SelectableAccordion = function SelectableAccordion(_ref3) {
  var children = _ref3.children,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'neutral_light' : _ref3$variant;
  return React.createElement(Wrapper$9, {
    variant: variant
  }, children);
};
SelectableAccordion.Header = Header$3;
SelectableAccordion.Body = Body$1;

var _templateObject$i, _templateObject2$i, _templateObject3$g, _templateObject4$g, _templateObject5$e;
var positionXModifier$1 = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
};
var positionYModifier$1 = {
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center'
};
var fillModifier = /*#__PURE__*/css(_templateObject$i || (_templateObject$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: ", ";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"])), /*#__PURE__*/transparentize(opacity.medium, colors.light));
var spinAnimation = /*#__PURE__*/keyframes(_templateObject2$i || (_templateObject2$i = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner$1 = /*#__PURE__*/styled.svg(_templateObject3$g || (_templateObject3$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  animation: ", " 1s linear infinite;\n"])), spinAnimation);
var Wrapper$8 = /*#__PURE__*/styled.div(_templateObject4$g || (_templateObject4$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var positionX = _ref.positionX,
    positionY = _ref.positionY,
    fill = _ref.expanded;
  return css(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n    align-items: ", ";\n    display: flex;\n    justify-content: ", ";\n    overflow: hidden;\n\n    ", "\n  "])), positionYModifier$1[positionY], positionXModifier$1[positionX], fill && fillModifier);
});

var getSize = function getSize(size) {
  var sizes = {
    small: 32,
    medium: 64,
    large: 128
  };
  if (sizes[size]) return sizes[size];
  if (typeof size === 'number') return size;
  return sizes.medium;
};
var Spinner = function Spinner(_ref) {
  var _ref$positionX = _ref.positionX,
    positionX = _ref$positionX === void 0 ? 'center' : _ref$positionX,
    _ref$positionY = _ref.positionY,
    positionY = _ref$positionY === void 0 ? 'center' : _ref$positionY,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    _ref$expanded = _ref.expanded,
    fill = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color;
  return React.createElement(Wrapper$8, {
    positionX: positionX,
    positionY: positionY,
    expanded: fill,
    "data-testid": "spinner-wrapper"
  }, React.createElement(Spinner$1, {
    width: getSize(size),
    height: getSize(size),
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Caricando..."
  }, React.createElement("path", {
    d: "M121 64c0 31.48-25.52 57-57 57S7 95.48 7 64 32.52 7 64 7s57 25.52 57 57Z",
    stroke: colors[color],
    strokeOpacity: ".25",
    strokeWidth: "14"
  }), React.createElement("path", {
    d: "M64 7.001c15.013-.105 29.453 5.841 40.143 16.53C114.832 34.221 120.896 48.778 121 64",
    stroke: "url(#" + color + ")",
    strokeWidth: "14",
    strokeLinecap: "round"
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: color,
    x1: "113.263",
    y1: "93.365",
    x2: "14.837",
    y2: "36.616",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    stopColor: colors[color]
  }), React.createElement("stop", {
    offset: ".755",
    stopColor: colors[color],
    stopOpacity: ".01"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: colors[color],
    stopOpacity: "0"
  })))));
};

var _templateObject$h, _templateObject2$h, _templateObject3$f, _templateObject4$f;
var CustomWrapper = /*#__PURE__*/styled.div(_templateObject$h || (_templateObject$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " 0;\n  height: 2rem;\n"])), spacing.medium);
var MenuContainer = /*#__PURE__*/styled.div(_templateObject2$h || (_templateObject2$h = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: ", " ", ";\n"])), spacing.small, spacing.medium);
var SimpleDividerContainer = /*#__PURE__*/styled.div(_templateObject3$f || (_templateObject3$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 0 ", ";\n"])), spacing.small);
var SimpleDivider = /*#__PURE__*/styled.div(_templateObject4$f || (_templateObject4$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin: ", " 0;\n  border: 0;\n  border-top: ", " solid ", ";\n"])), spacing.small, borderWidths.thin, colors.neutral_light);

var _excluded$a = ["noResultMessage"];
var LoadingMessage = function LoadingMessage(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color;
  return React.createElement(CustomWrapper, null, React.createElement(Spinner, {
    size: "small",
    color: color
  }));
};
var LoadingIndicator = function LoadingIndicator() {
  return null;
};
var noOptionsMessageStyles = {
  noOptionsMessage: function noOptionsMessage() {
    return {
      minHeight: '4rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1.4rem',
      color: colors.dark
    };
  }
};
var menuStyles = {
  menuPortal: function menuPortal(provided) {
    return _extends({}, provided, {
      zIndex: layers["default"],
      left: 0,
      top: undefined
    });
  },
  menu: function menu(provided) {
    return _extends({}, provided, {
      zIndex: layers["default"]
    });
  }
};
// TODO: Discover a way to type this props without break the onChange and states
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Input$2 = function Input(props) {
  return React.createElement(components.Input, _extends({}, props, {
    isHidden: false
  }));
};
// TODO: Discover a way to type this props without break the onChange and states
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var CustomMenuList = function CustomMenuList(_ref2) {
  var noResultMessage = _ref2.noResultMessage,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded$a);
  return React.createElement(React.Fragment, null, React.createElement(components.MenuList, _extends({}, props)), props.options.length > 0 && React.createElement(SimpleDividerContainer, null, React.createElement(SimpleDivider, null)), noResultMessage && !props.isLoading && React.createElement(MenuContainer, null, noResultMessage));
};

var _templateObject$g, _templateObject2$g, _templateObject3$e, _templateObject4$e, _templateObject5$d, _templateObject6$c, _templateObject7$b, _templateObject8$a, _templateObject9$9;
var AutocompleteWrapper = /*#__PURE__*/styled.div(_templateObject$g || (_templateObject$g = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n\n  ", "\n"])), function (_ref) {
  var color = _ref.color,
    error = _ref.error,
    _ref$scrollBarColor = _ref.scrollBarColor,
    scrollBarColor = _ref$scrollBarColor === void 0 ? colors.dark : _ref$scrollBarColor,
    variant = _ref.variant;
  return css(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n    .pantheon-autocomplete {\n      &__input-container {\n        color: ", ";\n      }\n\n      &__value-container {\n        color: ", ";\n        padding: 0;\n\n        &--has-value {\n          padding: 0;\n        }\n      }\n\n      &__control {\n        ", ";\n        border: ", " solid\n          ", ";\n        border-radius: ", ";\n        padding: ", " ", ";\n        box-shadow: none;\n        cursor: text;\n\n        &:hover {\n          border-color: ", ";\n        }\n      }\n\n      &__placeholder {\n        margin: 0;\n        color: ", ";\n      }\n\n      &__single-value {\n        color: ", ";\n      }\n\n      &__input-container {\n        margin: 0;\n        padding: 0;\n        cursor: text;\n        pointer-events: none;\n      }\n\n      &__indicator-separator {\n        background-color: ", ";\n      }\n\n      &__indicators {\n        padding: 0;\n\n        svg {\n          fill: ", ";\n        }\n      }\n\n      &__menu {\n        /* TODO: Create a specific token to handle this small iphones. */\n        @media only screen and (max-height: 700px) {\n          max-height: ", ";\n        }\n\n        z-index: ", ";\n        border-radius: ", ";\n        border: ", " solid\n          ", ";\n        box-shadow: ", ";\n        padding: ", " 0.5rem ", " 0;\n\n        ", "\n\n        &-list {\n          /* TODO: Create a specific token to handle this small iphones. */\n          @media only screen and (max-height: 700px) {\n            max-height: 18rem;\n          }\n\n          padding-top: 0;\n          padding-bottom: 0;\n\n          scrollbar-color: ", " transparent;\n\n          &::-webkit-scrollbar {\n            width: 0.5rem;\n            height: 5rem;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background-color: ", ";\n            border-radius: 0.5rem;\n          }\n        }\n\n        &__menu-notice--no-options {\n          padding: ", " 0;\n        }\n      }\n\n      &__option {\n        color: ", ";\n        padding-left: ", ";\n        ", ";\n\n        &:hover,\n        &--is-focused {\n          background-color: ", ";\n        }\n\n        &--is-selected {\n          background-color: ", ";\n        }\n      }\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    ", "\n  "])), color ? colors[color] : colors.secondary, color ? colors[color] : colors.secondary, typography.body_text_1, borderWidths.thin, color ? colors[color] : colors.secondary, radius.small, spacing.small, spacing.medium, color ? colors[color] : colors.secondary, colors.dark, colors.dark, colors.light, color ? colors[color] : colors.secondary, variant === 'default' ? '20rem' : '30rem', layers.alert, radius.small, borderWidths.thin, color ? colors[color] : colors.secondary, shadows.soft, spacing.small, spacing.small, firefoxOnly("padding: " + spacing.small + " 0;"), scrollBarColor, scrollBarColor, spacing.small, color ? colors[color] : colors.secondary, gutter["default"], typography.body_text_1, colors.neutral_extra_light, colors.neutral_extra_light, Label$3, colors.dark, error && css(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n      .pantheon-autocomplete {\n        &__control {\n          border-color: ", ";\n\n          &:hover {\n            border-color: ", ";\n          }\n        }\n\n        &__placeholder {\n          color: ", ";\n        }\n\n        &__single-value {\n          color: ", ";\n        }\n\n        &__indicators {\n          svg {\n            fill: ", ";\n          }\n        }\n\n        &__menu {\n          border-color: ", ";\n        }\n      }\n\n      ", " {\n        color: ", ";\n      }\n    "])), colors.state__error, colors.state__error, colors.state__error, colors.state__error, colors.state__error, colors.state__error, Label$3, colors.state__error));
});
var Label$3 = /*#__PURE__*/styled.label(_templateObject4$e || (_templateObject4$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n  color: ", ";\n  position: absolute;\n  z-index: ", ";\n  padding: ", " ", ";\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s linear, top 0.2s linear, font-size 0.2s linear,\n    color 0.2s linear;\n\n  ", "\n"])), typography.body_text_1, colors.dark, layers.above, spacing.small, spacing.medium, function (_ref2) {
  var isFilled = _ref2.isFilled;
  return isFilled && css(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n      visibility: visible;\n      opacity: 1;\n      top: -1.7rem;\n      background-color: ", ";\n      font-size: 1rem;\n      margin: ", " ", ";\n      padding: 0 ", ";\n      transition: opacity 0.2s linear, top 0.2s linear, font-size 0.2s linear,\n        color 0.2s linear;\n    "])), colors.light, spacing.small, spacing.medium, spacing.small);
});
var HelperText$1 = /*#__PURE__*/styled.p(_templateObject6$c || (_templateObject6$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  bottom: -", ";\n  left: ", ";\n  display: block;\n  font-size: 1rem;\n  position: absolute;\n  color: ", ";\n"])), spacing.medium, spacing.medium, colors.state__error);
var CustomDropdownIndicator = /*#__PURE__*/styled.div(_templateObject7$b || (_templateObject7$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 100%;\n  position: absolute;\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), borderWidths.thin);
var SearchIconWrapper = /*#__PURE__*/styled.div(_templateObject8$a || (_templateObject8$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 100%;\n  padding-right: ", ";\n  border-radius: ", ";\n  display: flex;\n  align-items: center;\n"])), spacing.medium, radius.medium);
var CloseButton$2 = /*#__PURE__*/styled.button(_templateObject9$9 || (_templateObject9$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  height: 100%;\n  padding-right: ", ";\n  border-radius: ", ";\n"])), spacing.medium, radius.medium);

var Autocomplete = function Autocomplete(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'secondary' : _ref$color,
    value = _ref.value,
    inputValue = _ref.inputValue,
    isLoading = _ref.isLoading,
    loadingSpinnerColor = _ref.loadingSpinnerColor,
    options = _ref.options,
    noResultMessage = _ref.noResultMessage,
    error = _ref.error,
    onClear = _ref.onClear,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    _onInputChange = _ref.onInputChange,
    _onChange = _ref.onChange,
    scrollBarColor = _ref.scrollBarColor;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useState2 = useState(false),
    isOptionSelected = _useState2[0],
    setIsOptionSelected = _useState2[1];
  var _useState3 = useState(inputValue),
    inputText = _useState3[0],
    setInputText = _useState3[1];
  var _useState4 = useState(options),
    menuOptions = _useState4[0],
    setMenuOptions = _useState4[1];
  var _useState5 = useState(false),
    debounceFinished = _useState5[0],
    setDebounceFinished = _useState5[1];
  var timerId = useRef(0);
  var autoCompleteRef = useRef(null);
  var reactSelectRef = useRef(null);
  var iconColor = error ? 'state__error' : color;
  var customLoadingMessage = function customLoadingMessage() {
    return React.createElement(LoadingMessage, {
      color: loadingSpinnerColor
    });
  };
  var customNoOptionsMessage = variant === 'default' ? components.NoOptionsMessage : function () {
    return null;
  };
  var customMenuList = variant === 'default' ? components.MenuList : function (props) {
    return React.createElement(CustomMenuList, _extends({
      noResultMessage: noResultMessage
    }, props));
  };
  useEffect(function () {
    setInputText(value == null ? void 0 : value.label);
  }, [value]);
  useEffect(function () {
    setMenuOptions(options);
  }, [options]);
  return React.createElement(AutocompleteWrapper, {
    ref: autoCompleteRef,
    color: color,
    error: error,
    scrollBarColor: scrollBarColor
  }, React.createElement(Label$3, {
    isFilled: isFocused || isOptionSelected || !!inputText
  }, label), React.createElement(ReactSelect, {
    id: id,
    ref: reactSelectRef,
    inputValue: inputText,
    controlShouldRenderValue: false,
    filterOption: function filterOption() {
      return true;
    },
    value: value,
    onFocus: function onFocus(event) {
      setIsFocused(true);
      var inputValueEnd = event.target.value.length;
      event.target.setSelectionRange(inputValueEnd, inputValueEnd);
      _onFocus && _onFocus(event);
    },
    onBlur: function onBlur(event) {
      setIsFocused(false);
      setMenuOptions([]);
      _onBlur && _onBlur(event);
    },
    placeholder: !isFocused && label,
    options: inputText ? menuOptions : [],
    classNamePrefix: "pantheon-autocomplete",
    noOptionsMessage: function noOptionsMessage() {
      // NOTE: To show this message, the user need to stop typing and have no options available.
      return debounceFinished && !!inputText && !(options != null && options.length) ? noResultMessage : null;
    },
    onInputChange: function onInputChange(newValue, action) {
      switch (action.action) {
        case 'input-blur':
          setInputText(value == null ? void 0 : value.label);
          break;
        case 'input-change':
          setDebounceFinished(false);
          setInputText(newValue);
          clearTimeout(timerId.current);
          timerId.current = window.setTimeout(function () {
            _onInputChange(newValue);
            setDebounceFinished(true);
          }, 500);
          break;
      }
    },
    components: {
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      LoadingMessage: customLoadingMessage,
      NoOptionsMessage: customNoOptionsMessage,
      LoadingIndicator: LoadingIndicator,
      Input: Input$2,
      MenuList: customMenuList
    },
    onChange: function onChange(newValue) {
      setIsOptionSelected(true);
      var val = Array.isArray(newValue) ? newValue[0] : newValue;
      _onChange && _onChange(val);
      val && setInputText(val.label);
      reactSelectRef.current && reactSelectRef.current.blur();
    },
    menuPortalTarget: autoCompleteRef.current,
    styles: _extends({}, noOptionsMessageStyles, menuStyles),
    isLoading: isLoading
  }), error && React.createElement(HelperText$1, null, error), React.createElement(CustomDropdownIndicator, null, !inputText && !isOptionSelected ? React.createElement(SearchIconWrapper, null, React.createElement(Search, {
    color: iconColor
  })) : React.createElement(CloseButton$2, {
    onPointerDown: function onPointerDown() {
      setIsOptionSelected(false);
      reactSelectRef.current && reactSelectRef.current.blur();
      onClear && onClear();
    }
  }, React.createElement(Close, {
    color: iconColor
  }))));
};

var _templateObject$f, _templateObject2$f, _templateObject3$d, _templateObject4$d, _templateObject5$c, _templateObject6$b, _templateObject7$a, _templateObject8$9, _templateObject9$8, _templateObject10$7, _templateObject11$7, _templateObject12$7, _templateObject13$7, _templateObject14$5, _templateObject15$4, _templateObject16$4, _templateObject17$3, _templateObject18$4, _templateObject19$4, _templateObject20$4, _templateObject21$4, _templateObject22$4, _templateObject23$2, _templateObject24$2, _templateObject25$2, _templateObject26$2, _templateObject27$2;
var ButtonIcon = /*#__PURE__*/styled.div(_templateObject$f || (_templateObject$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  svg {\n    color: currentColor;\n    height: 100%;\n    width: 100%;\n  }\n"])));
var ButtonContent = /*#__PURE__*/styled.span(_templateObject2$f || (_templateObject2$f = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n\n  color: currentColor;\n  font-weight: 700;\n  line-height: 1;\n"])), typography['body_text_2']);
var sizeModifiers = {
  small: function small(hasIcon) {
    return css(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n    height: 2.4rem;\n    padding: ", ";\n\n    &::before {\n      padding: ", ";\n    }\n\n    ", " {\n      width: 1.6rem;\n    }\n  "])), hasIcon ? '0.5rem' : gutter.small, borderWidths.thin, ButtonIcon);
  },
  medium: function medium(hasIcon, shrinked) {
    return css(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n    height: 3.2rem;\n    min-width: ", ";\n\n    ", ";\n\n    ", " {\n      width: 2rem;\n    }\n  "])), hasIcon ? 'auto' : '17rem', shrinked && css(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n      min-width: unset;\n    "]))), ButtonIcon);
  },
  large: function large(hasIcon, shrinked) {
    return css(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n    height: 4rem;\n    min-width: ", ";\n\n    ", ";\n\n    ", " {\n      width: 2.8rem;\n    }\n\n    ", " {\n      font-size: 1.6rem;\n    }\n  "])), hasIcon ? 'auto' : '24rem', shrinked && css(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n      min-width: unset;\n    "]))), ButtonIcon, ButtonContent);
  }
};
var iOSBorder = function iOSBorder(color, iOSVersion) {
  return css(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n    @supports (background: -webkit-named-image(i)) {\n      border: ", ";\n    }\n  "])), iOSVersion < 16 ? borderWidths.small + " solid " + colors[color] : 'none');
};
var colorModifiers = {
  primary: function primary(variant, iOSVersion) {
    return css(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n    background: linear-gradient(to right, #8533fb, #4e88fc, #8533fb);\n\n    &::before {\n      background: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), colors.gradient__secondary_reverse, variant === 'outline' && css(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n      transition: background-color 0.25s ease;\n\n      ", "\n\n      &:hover {\n        background: ", ";\n      }\n    "])), colors.secondary, iOSBorder('secondary', iOSVersion), rgba(colors.light, opacity.extreme)), variant === 'clear' && css(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.secondary), variant === 'overlay' && css(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.light, colors.secondary));
  },
  secondary: function secondary(variant, iOSVersion) {
    return css(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteralLoose(["\n    background: linear-gradient(to right, #35baec, #28e7c2, #35baec);\n\n    &::before {\n      background: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), colors.gradient__primary_reverse, variant === 'outline' && css(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n      transition: background-color 0.25s ease;\n\n      ", "\n\n      &:hover {\n        background: ", ";\n      }\n    "])), colors.primary, iOSBorder('primary', iOSVersion), rgba(colors.light, 0.15)), variant === 'clear' && css(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.primary), variant === 'overlay' && css(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.light, colors.primary));
  },
  light: function light(variant, iOSVersion) {
    return css(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n\n    &::before {\n      display: none;\n    }\n\n    ", "\n\n    ", "\n  "])), colors.light, colors.dark, variant === 'outline' && css(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n      border: ", " solid ", ";\n      transition: background-color 0.25s ease;\n\n      ", "\n\n      &:hover {\n        background: ", ";\n      }\n    "])), colors.light, borderWidths.thin, colors.light, iOSBorder('light', iOSVersion), rgba(colors.light, 0.15)), variant === 'clear' && css(_templateObject19$4 || (_templateObject19$4 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n    "])), colors.light));
  },
  state__error: function state__error(variant, iOSVersion) {
    return css(_templateObject20$4 || (_templateObject20$4 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n\n    &::before {\n      background: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), colors.state__error, colors.state__error, variant === 'outline' && css(_templateObject21$4 || (_templateObject21$4 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n      transition: background-color 0.25s ease;\n\n      ", "\n\n      &:hover {\n        background: ", ";\n      }\n    "])), colors.state__error, iOSBorder('state__error', iOSVersion), rgba(colors.light, 0.15)), variant === 'clear' && css(_templateObject22$4 || (_templateObject22$4 = _taggedTemplateLiteralLoose(["\n      background: transparent;\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.state__error), variant === 'overlay' && css(_templateObject23$2 || (_templateObject23$2 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      color: ", ";\n\n      &::before {\n        display: none;\n      }\n    "])), colors.light, colors.state__error));
  }
};
var Button$3 = /*#__PURE__*/styled.button(_templateObject24$2 || (_templateObject24$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var size = _ref.size,
    color = _ref.color,
    variant = _ref.variant,
    disabled = _ref.disabled,
    extended = _ref.extended,
    shrinked = _ref.shrinked,
    hasIcon = _ref.hasIcon,
    iOSVersion = _ref.iOSVersion;
  return css(_templateObject25$2 || (_templateObject25$2 = _taggedTemplateLiteralLoose(["\n    align-items: center;\n    background-size: 200% 100% !important;\n    border-radius: ", ";\n    border: 0;\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    padding: 0 ", ";\n    position: relative;\n    text-decoration: none;\n    transition: background-position 0.25s ease-in-out;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    &:hover {\n      background-position: ", ";\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      border-radius: ", ";\n      padding: ", ";\n      -webkit-mask: linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: destination-out;\n      mask-composite: exclude;\n      pointer-events: none;\n    }\n\n    ", "\n    ", "\n  "])), radius.small, colors.light, gutter.small, !!extended && css(_templateObject26$2 || (_templateObject26$2 = _taggedTemplateLiteralLoose(["\n      width: 100%;\n    "]))), gap(gutter.small), !!disabled && css(_templateObject27$2 || (_templateObject27$2 = _taggedTemplateLiteralLoose(["\n      opacity: ", ";\n      cursor: not-allowed;\n    "])), opacity.hard), !disabled && '100% 0', radius.small, borderWidths.small, !!size && sizeModifiers[size](hasIcon, shrinked), !!color && colorModifiers[color](variant, iOSVersion));
});

var _excluded$9 = ["as", "color", "disabled", "extended", "shrinked", "loading", "icon", "onClick", "size", "variant", "children"];
// eslint-disable-next-line react/display-name
var Button$2 = /*#__PURE__*/React.forwardRef(function (_ref,
// TODO: review this later to remove the any type.
ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'button' : _ref$as,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$extended = _ref.extended,
    extended = _ref$extended === void 0 ? false : _ref$extended,
    _ref$shrinked = _ref.shrinked,
    shrinked = _ref$shrinked === void 0 ? false : _ref$shrinked,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    icon = _ref.icon,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var _useUserDevice = useUserDevice(),
    OSVersion = _useUserDevice.OSVersion;
  return React.createElement(Button$3, _extends({
    variant: variant,
    color: color,
    size: size,
    disabled: disabled || loading,
    extended: extended,
    shrinked: shrinked,
    onClick: onClick,
    hasIcon: !children && !!icon,
    iOSVersion: OSVersion,
    as: as,
    ref: ref
  }, rest), !!icon && !loading && React.createElement(ButtonIcon, null, React.createElement(icons[icon])), !!loading && React.createElement(Spinner, {
    size: size === 'small' ? 12 : size === 'large' ? 28 : 18,
    color: "light"
  }), !!children && React.createElement(ButtonContent, null, children));
});

var _templateObject$e, _templateObject2$e, _templateObject3$c, _templateObject4$c, _templateObject5$b, _templateObject6$a, _templateObject7$9, _templateObject8$8;
var containerVariants = {
  "default": /*#__PURE__*/css(_templateObject$e || (_templateObject$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n  "])), colors.dark, colors.text__light),
  light: /*#__PURE__*/css(_templateObject2$e || (_templateObject2$e = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n  "])), colors.light, colors.text__primary),
  transparent: /*#__PURE__*/css(_templateObject3$c || (_templateObject3$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    background-color: transparent;\n    color: ", ";\n  "])), colors.text__primary)
};
function getRoundButtonPadding(shrinked, hasOnlyIcon) {
  if (hasOnlyIcon) {
    return spacing.none;
  }
  if (shrinked) {
    return spacing.small;
  }
  return spacing.small + " " + spacing.medium;
}
var Button$1 = /*#__PURE__*/styled.button(_templateObject4$c || (_templateObject4$c = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'none' : _ref$borderColor,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 'small' : _ref$borderWidth,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$shrinked = _ref.shrinked,
    shrinked = _ref$shrinked === void 0 ? false : _ref$shrinked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    hasOnlyIcon = _ref.hasOnlyIcon;
  return css(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n    background: none;\n    border: none;\n    border-radius: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    min-width: ", ";\n    height: 4rem;\n    text-decoration: none;\n    padding: ", ";\n    pointer-events: auto;\n    cursor: pointer;\n\n    ", ";\n\n    ", ";\n    ", ";\n    ", "\n\n    ", "\n\n    ", "\n\n    svg {\n      color: currentColor;\n    }\n\n    border: ", " solid\n      ", ";\n\n    box-sizing: border-box;\n\n    ", "\n  "])), radius.large, shrinked ? '4rem' : '19rem', getRoundButtonPadding(shrinked, hasOnlyIcon), gap(spacing.small), !!variant && containerVariants[variant], expanded && 'width: 100%', reverse && 'flex-direction: row-reverse;', !!disabled && css(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n      opacity: ", ";\n      cursor: not-allowed;\n    "])), opacity.hard), hasOnlyIcon && css(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n      height: 4rem;\n      width: 4rem;\n    "]))), borderWidths[borderWidth], borderColor === 'none' ? 'none' : colors[borderColor], media.greaterThan('tablet')(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n      max-width: 30rem;\n    "]))));
});

var _excluded$8 = ["as", "variant", "borderColor", "borderWidth", "icon", "reverse", "loading", "expanded", "shrinked", "disabled", "children"];
// eslint-disable-next-line react/display-name
var RoundButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'button' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? 'none' : _ref$borderColor,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 'small' : _ref$borderWidth,
    icon = _ref.icon,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    _ref$shrinked = _ref.shrinked,
    shrinked = _ref$shrinked === void 0 ? false : _ref$shrinked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  return React.createElement(Button$1, _extends({
    as: as,
    icon: icon,
    variant: variant,
    borderColor: borderColor,
    borderWidth: borderWidth,
    expanded: expanded,
    reverse: reverse,
    shrinked: shrinked,
    hasOnlyIcon: !!icon && !children,
    disabled: disabled,
    ref: ref
  }, rest), !!icon && !loading &&
  /*
   * TODO: find a way to make the <path /> tag follow the width/height from the svg
   * today, the svg being 18px make the path cover only 14px.
   */
  React.createElement(React.Fragment, null, React.createElement(icons[icon], {
    width: 20,
    height: 20
  })), !!loading && React.createElement(Spinner, {
    size: 18,
    color: "light"
  }), !!children && React.createElement(ButtonContent, null, children));
});

var ViewportContext = /*#__PURE__*/createContext({});
var ViewportProvider = function ViewportProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(0),
    viewportSize = _useState[0],
    setViewportSize = _useState[1];
  var matchMedia = useCallback(function (query) {
    if (viewportSize > 0) return window.matchMedia(query).matches;
    return false;
  }, [viewportSize]);
  var lessThan = function lessThan(breakpoint) {
    var maxWidthSubtract = math(breakpoints[breakpoint] + " - 1px");
    return matchMedia("(max-width: " + maxWidthSubtract + ")");
  };
  var greaterThan = function greaterThan(breakpoint) {
    return matchMedia("(min-width: " + breakpoints[breakpoint] + ")");
  };
  var handleWindowResize = function handleWindowResize() {
    setViewportSize(window.innerWidth);
  };
  useEffect(function () {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return React.createElement(ViewportContext.Provider, {
    value: {
      viewportSize: viewportSize,
      greaterThan: greaterThan,
      lessThan: lessThan
    }
  }, children);
};
var useViewport = function useViewport() {
  var context = useContext(ViewportContext);
  if (!context) {
    throw new Error('useViewport hook must be used under ViewportProvider');
  }
  return context;
};

var MediaMatch = function MediaMatch(_ref) {
  var greaterThanBreakpoint = _ref.greaterThan,
    lessThanBreakpoint = _ref.lessThan,
    children = _ref.children;
  var _useViewport = useViewport(),
    greaterThan = _useViewport.greaterThan,
    lessThan = _useViewport.lessThan;
  if (greaterThanBreakpoint) {
    if (greaterThan(greaterThanBreakpoint)) return React.createElement(React.Fragment, null, children);
    return null;
  }
  if (lessThanBreakpoint) {
    if (lessThan(lessThanBreakpoint)) return React.createElement(React.Fragment, null, children);
    return null;
  }
  return React.createElement(React.Fragment, null, children);
};

var _templateObject$d, _templateObject2$d, _templateObject3$b, _templateObject4$b, _templateObject5$a, _templateObject6$9, _templateObject7$8, _templateObject8$7, _templateObject9$7, _templateObject10$6, _templateObject11$6, _templateObject12$6, _templateObject13$6, _templateObject14$4, _templateObject15$3, _templateObject16$3, _templateObject17$2, _templateObject18$3, _templateObject19$3, _templateObject20$3, _templateObject21$3, _templateObject22$3, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36;
var NavigationElementWrapper = /*#__PURE__*/styled.div(_templateObject$d || (_templateObject$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  padding: inherit;\n"])));
var CalendarDescription = /*#__PURE__*/styled.div(_templateObject2$d || (_templateObject2$d = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  margin-top: ", ";\n\n  ", "\n"])), spacing.medium, /*#__PURE__*/media.greaterThan('tablet')(_templateObject3$b || (_templateObject3$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin-top: ", ";\n  "])), spacing.none));
var CalendarFooter = /*#__PURE__*/styled.div(_templateObject4$b || (_templateObject4$b = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"])));
var CalendarWrapper = /*#__PURE__*/styled.div(_templateObject5$a || (_templateObject5$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref) {
  var navigationHighlight = _ref.navigationHighlight,
    navigationElement = _ref.navigationElement,
    navigationContainerHeight = _ref.navigationContainerHeight,
    sideContentHeader = _ref.sideContentHeader,
    sideContentBody = _ref.sideContentBody,
    sideContentHeaderHeight = _ref.sideContentHeaderHeight,
    desktopCta = _ref.desktopCta,
    _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === void 0 ? colors.secondary : _ref$highlightColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'dark' : _ref$textColor,
    _ref$activeTextColor = _ref.activeTextColor,
    activeTextColor = _ref$activeTextColor === void 0 ? 'light' : _ref$activeTextColor,
    disableDesktopStyles = _ref.disableDesktopStyles;
  return css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    position: relative;\n    background-color: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    user-select: none;\n    ", ";\n\n    ", "\n\n    .react-calendar {\n      width: 100%;\n      position: relative;\n\n      &__navigation {\n        display: flex;\n        align-content: center;\n        border-top-left-radius: ", ";\n        border-top-right-radius: ", ";\n        margin: 0;\n        position: relative;\n\n        ", "\n\n        ", ";\n\n        background-color: ", ";\n        margin-bottom: ", ";\n\n        ", ";\n\n        ", "\n\n        ", "\n\n        &__label {\n          max-width: 13rem;\n          color: ", ";\n\n          ", ";\n\n          font-weight: ", ";\n          font-size: 1.6rem;\n\n          ", ";\n        }\n\n        &__arrow,\n        &__label {\n          background: none;\n          border: none;\n        }\n\n        &__arrow {\n          cursor: pointer;\n          & svg {\n            width: 1.8rem;\n            height: 1.8rem;\n            border-radius: ", ";\n            color: ", ";\n\n            ", "\n          }\n\n          &:disabled {\n            svg {\n              color: ", ";\n              cursor: not-allowed;\n            }\n          }\n        }\n\n        &__next-button {\n          svg {\n            transform: rotate(-90deg);\n          }\n        }\n\n        &__prev-button {\n          svg {\n            transform: rotate(90deg);\n          }\n        }\n      }\n\n      &__viewContainer {\n        margin-bottom: ", ";\n      }\n\n      &__month-view {\n        ", "\n\n        &::after {\n          content: '';\n          background: ", ";\n          position: absolute;\n          bottom: -1rem;\n          width: 100%;\n          height: ", ";\n\n          ", "\n        }\n\n        &__days {\n          border-top: ", " solid ", ";\n          border-bottom: ", " solid ", ";\n        }\n\n        &__days,\n        &__weekdays {\n          padding: ", " 0;\n          ", "\n        }\n\n        &__weekdays {\n          text-align: center;\n          color: ", ";\n          position: relative;\n          background-color: ", ";\n          margin-bottom: ", ";\n          padding-bottom: ", ";\n          ", ";\n          font-size: 1rem !important;\n\n          ", ";\n\n          ", "\n\n          &__weekday {\n            text-decoration: none;\n\n            abbr {\n              text-decoration: none;\n            }\n          }\n        }\n      }\n\n      &__tile {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background: none;\n        border: none;\n        color: ", ";\n        ", "\n        font-size: 1rem !important;\n        margin-bottom: ", ";\n\n        abbr {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          height: 3.6rem;\n          width: 3.6rem;\n          cursor: pointer;\n        }\n\n        ", ";\n\n        &:not(&--active):not(&:disabled) abbr:hover {\n          background-color: ", ";\n          border-radius: ", ";\n        }\n\n        &--now abbr {\n          background-color: ", ";\n          border-radius: ", ";\n        }\n\n        &--active abbr {\n          background-color: ", ";\n          border-radius: ", ";\n          color: ", ";\n        }\n\n        &:not(:disabled) {\n          font-weight: ", ";\n        }\n\n        &:disabled {\n          color: ", ";\n          cursor: not-allowed;\n\n          &:hover {\n            border: none;\n          }\n        }\n      }\n    }\n\n    ", " {\n      right: 0;\n\n      ", "\n\n      ", "\n    }\n\n    ", " {\n      ", "\n    }\n\n    ", " {\n      ", "\n    }\n  "])), colors.neutral_light, spacing.medium, radius.medium, disableDesktopStyles && "max-width: 45rem", !!sideContentHeader && sideContentBody && css(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      flex-direction: column;\n    "]))), radius.medium, radius.medium, !!sideContentBody && !disableDesktopStyles && media.greaterThan('tablet')(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n          width: 50%;\n        "]))), !!navigationContainerHeight && "height: " + navigationContainerHeight, navigationHighlight ? colors.neutral_extra_light : 'initial', spacing.medium, !navigationElement && 'justify-content: space-between;', !!sideContentHeader && navigationHighlight && !disableDesktopStyles && media.greaterThan('tablet')(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n          &::after {\n            content: '';\n            position: absolute;\n            background-color: ", ";\n            bottom: -2rem;\n            left: 0;\n            width: 100%;\n            height: 2rem;\n          }\n        "])), colors.neutral_extra_light), !disableDesktopStyles && media.greaterThan('tablet')(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n          margin-bottom: ", ";\n        "])), spacing.none), colors.dark, !navigationElement && !sideContentBody && !disableDesktopStyles && media.greaterThan('tablet')(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteralLoose(["\n            ", ";\n            margin-bottom: ", ";\n          "])), new_typography.heading_5, spacing.none), font_weight.bold, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteralLoose(["\n            max-width: ", ";\n          "])), sideContentHeader ? 'calc(50% - 3.8rem - 3.8rem - 2rem)' : '21rem'), radius.small, colors.dark, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteralLoose(["\n              width: 3.8rem;\n              height: 3.8rem;\n              padding: ", ";\n            "])), spacing.small), colors.neutral, spacing.small, !!sideContentHeader && !disableDesktopStyles && media.greaterThan('tablet')(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteralLoose(["\n          width: 50%;\n        "]))), colors.neutral_light, borderWidths.thin, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteralLoose(["\n            left: ", ";\n            width: ", ";\n          "])), spacing.medium, sideContentHeader ? 'calc(50% - 4rem)' : 'calc(100% - 4rem)'), borderWidths.thin, colors.light, borderWidths.thin, colors.light, spacing.small, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteralLoose(["\n            margin: ", ";\n          "])), sideContentHeader || sideContentBody ? "" + spacing.medium : spacing.small + " " + spacing.medium), colors.dark, navigationHighlight ? colors.neutral_extra_light : 'initial', spacing.small, spacing.small, new_typography.body_text_3, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n            font-size: 1.4rem !important;\n            margin-bottom: ", ";\n          "])), spacing.small), !navigationHighlight && media.lessThan('tablet')(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteralLoose(["\n            &::after {\n              content: '';\n              background: ", ";\n              position: absolute;\n              bottom: -1rem;\n              width: 100%;\n              height: ", ";\n            }\n          "])), colors.neutral_light, borderWidths.thin), colors[textColor], new_typography.body_text_3, spacing.small, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteralLoose(["\n          justify-content: center;\n          width: calc(100% * 1/7 );\n          margin-bottom: ", ";\n          padding: ", ";\n          font-size: 1.4rem !important;\n\n          abbr {\n            height: 5rem;\n            width: 5rem;\n          }\n        "])), spacing.none, spacing.none), colors.light, radius.small, colors.light, radius.small, highlightColor, radius.small, colors[activeTextColor], font_weight.bold, colors.neutral, NavigationElementWrapper, !!sideContentHeader && media.lessThan('tablet')(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteralLoose(["\n        ", "\n      "])), "top: calc(" + sideContentHeaderHeight + "px + " + spacing.medium + ")"), !disableDesktopStyles && media.greaterThan('tablet')(_templateObject21$3 || (_templateObject21$3 = _taggedTemplateLiteralLoose(["\n        right: ", ";\n      "])), sideContentHeader ? '50%' : '0'), CalendarFooter, desktopCta && css(_templateObject22$3 || (_templateObject22$3 = _taggedTemplateLiteralLoose(["\n        align-items: center;\n      "]))), CalendarDescription, !disableDesktopStyles && media.greaterThan('tablet')(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteralLoose(["\n        padding: 0 ", ";\n        };\n      "])), spacing.medium));
});
var Description$1 = /*#__PURE__*/styled.p(_templateObject24$1 || (_templateObject24$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var color = _ref2.color,
    border = _ref2.border;
  return css(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1rem;\n    color: ", ";\n    font-weight: ", ";\n\n    ", ";\n\n    &:not(:last-child) {\n      margin-right: ", ";\n\n      ", "\n    }\n\n    &::before {\n      content: '';\n      display: inline-block;\n      width: 1.2rem;\n      height: 1.2rem;\n      margin-right: ", ";\n      border-radius: ", ";\n      ", "\n    }\n  "])), colors.dark, font_weight.light, media.greaterThan('tablet')(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteralLoose(["\n      font-size: 1.6rem;\n    "]))), spacing.medium, isMobileSmall()(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteralLoose(["\n        margin-right: ", ";\n      "])), spacing.small), spacing.small, radius.large, border ? css(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteralLoose(["\n            border: ", " solid ", ";\n          "])), borderWidths.thin, colors[color]) : css(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteralLoose(["\n            background-color: ", ";\n          "])), colors[color]));
});
var DesktopCtaWrapper = /*#__PURE__*/styled.div(_templateObject30 || (_templateObject30 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: ", ";\n"])), spacing.medium);
var SideContentWrapper$1 = /*#__PURE__*/styled.div(_templateObject31 || (_templateObject31 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 100%;\n\n  ", "\n"])), /*#__PURE__*/media.greaterThan('tablet')(_templateObject32 || (_templateObject32 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    position: absolute;\n    width: 50%;\n    height: 100%;\n    right: 0;\n    padding-left: ", ";\n  "])), spacing.medium));
var SideContentHeaderWrapper = /*#__PURE__*/styled.div(_templateObject33 || (_templateObject33 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), /*#__PURE__*/media.greaterThan('tablet')(_templateObject34 || (_templateObject34 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    height: 10rem;\n  "]))));
var SideContentBodyWrapper = /*#__PURE__*/styled.div(_templateObject35 || (_templateObject35 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n\n  ", "\n"])), spacing.medium, /*#__PURE__*/media.greaterThan('tablet')(_templateObject36 || (_templateObject36 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    height: calc(100% - 10rem);\n  "]))));

var _excluded$7 = ["availableDays", "minDate", "maxDate", "handleDayClick", "handleMonthChange", "navigationElement", "navigationContainerHeight", "navigationHighlight", "sideContentHeader", "sideContentBody", "desktopCta", "highlightColor", "textColor", "activeTextColor", "disableDesktopStyles", "locale", "translations"];
var Calendar = function Calendar(_ref) {
  var availableDays = _ref.availableDays,
    _ref$minDate = _ref.minDate,
    minDate = _ref$minDate === void 0 ? new Date() : _ref$minDate,
    maxDate = _ref.maxDate,
    handleDayClick = _ref.handleDayClick,
    handleMonthChange = _ref.handleMonthChange,
    navigationElement = _ref.navigationElement,
    navigationContainerHeight = _ref.navigationContainerHeight,
    _ref$navigationHighli = _ref.navigationHighlight,
    navigationHighlight = _ref$navigationHighli === void 0 ? false : _ref$navigationHighli,
    sideContentHeader = _ref.sideContentHeader,
    sideContentBody = _ref.sideContentBody,
    desktopCta = _ref.desktopCta,
    highlightColor = _ref.highlightColor,
    textColor = _ref.textColor,
    activeTextColor = _ref.activeTextColor,
    disableDesktopStyles = _ref.disableDesktopStyles,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'it-IT' : _ref$locale,
    translations = _ref.translations,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var _useState = useState(),
    sideContentHeaderHeight = _useState[0],
    setSideContentHeaderHeight = _useState[1];
  var sideContentHeaderRef = useRef(null);
  useEffect(function () {
    var getSideContentHeaderHeight = function getSideContentHeaderHeight() {
      if (sideContentHeader && sideContentHeaderRef.current) {
        setSideContentHeaderHeight(sideContentHeaderRef.current.offsetHeight);
      }
    };
    getSideContentHeaderHeight();
    window.addEventListener('resize', getSideContentHeaderHeight);
    return function () {
      window.removeEventListener('resize', getSideContentHeaderHeight);
    };
  }, [sideContentHeader]);
  return React.createElement(CalendarWrapper, {
    navigationHighlight: navigationHighlight,
    navigationElement: !!navigationElement,
    navigationContainerHeight: navigationContainerHeight,
    sideContentHeader: !!sideContentHeader,
    sideContentBody: !!sideContentBody,
    sideContentHeaderHeight: sideContentHeaderHeight,
    desktopCta: !!desktopCta,
    highlightColor: highlightColor,
    activeTextColor: activeTextColor,
    textColor: textColor,
    disableDesktopStyles: disableDesktopStyles
  }, React.createElement(MediaMatch, {
    lessThan: "tablet"
  }, React.createElement(SideContentHeaderWrapper, {
    ref: sideContentHeaderRef
  }, sideContentHeader)), React.createElement(ReactCalendar, _extends({}, props, {
    locale: locale,
    minDetail: "month",
    maxDetail: "month",
    defaultView: "month",
    nextLabel: React.createElement(ArrowDown, {
      color: "neutral"
    }),
    prevLabel: React.createElement(ArrowDown, {
      color: "neutral"
    }),
    nextAriaLabel: (translations == null ? void 0 : translations.nextAriaLabel) || 'il prossimo mese',
    prevAriaLabel: (translations == null ? void 0 : translations.prevAriaLabel) || 'lo scorso mese',
    next2Label: null,
    prev2Label: null,
    minDate: minDate,
    maxDate: maxDate,
    tileDisabled: function tileDisabled(_ref2) {
      var date = _ref2.date;
      return !!(availableDays != null && availableDays.every(function (availableDay) {
        return availableDay.toDateString() !== date.toDateString();
      }));
    },
    onActiveStartDateChange: function onActiveStartDateChange(handleMonthChangeprops) {
      return handleMonthChange && handleMonthChange(handleMonthChangeprops);
    },
    onClickDay: function onClickDay(value) {
      return handleDayClick && handleDayClick(value);
    },
    navigationLabel: function navigationLabel(_ref3) {
      var date = _ref3.date;
      return date.toLocaleString(locale, {
        month: 'long',
        year: 'numeric'
      }).replace(' ', ', ');
    },
    navigationAriaLabel: (translations == null ? void 0 : translations.navigationAriaLabel) || 'navigazione del calendario'
  })), React.createElement(CalendarFooter, null, React.createElement(CalendarDescription, null, React.createElement(Description$1, {
    color: "dark"
  }, (translations == null ? void 0 : translations.disposition) || 'A disposizione'), React.createElement(Description$1, {
    color: "neutral"
  }, (translations == null ? void 0 : translations.notAvailable) || 'Non disponibile'), React.createElement(Description$1, {
    color: "light"
  }, (translations == null ? void 0 : translations.today) || 'Oggi')), desktopCta && React.createElement(MediaMatch, {
    greaterThan: "tablet"
  }, React.createElement(DesktopCtaWrapper, null, desktopCta))), navigationElement && !sideContentBody && React.createElement(NavigationElementWrapper, null, navigationElement), sideContentBody && React.createElement(MediaMatch, {
    lessThan: "tablet"
  }, React.createElement(SideContentBodyWrapper, null, sideContentBody)), sideContentHeader && sideContentBody && React.createElement(MediaMatch, {
    greaterThan: "tablet"
  }, React.createElement(SideContentWrapper$1, null, React.createElement(SideContentHeaderWrapper, null, sideContentHeader), React.createElement(SideContentBodyWrapper, null, sideContentBody))));
};

var _templateObject$c, _templateObject2$c, _templateObject3$a, _templateObject4$a, _templateObject5$9, _templateObject6$8, _templateObject7$7, _templateObject8$6, _templateObject9$6, _templateObject10$5, _templateObject11$5, _templateObject12$5, _templateObject13$5, _templateObject14$3, _templateObject15$2, _templateObject16$2, _templateObject17$1, _templateObject18$2, _templateObject19$2, _templateObject20$2, _templateObject21$2, _templateObject22$2;
/**
 * TODO: Drop this. The element should control it's own style.
 */
var imageSizeModifiers = {
  small: function small() {
    return css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n    > img {\n      height: 6.4rem;\n    }\n  "])));
  },
  medium: function medium() {
    return css(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n    > img {\n      height: 8.8rem;\n    }\n  "])));
  },
  large: function large() {
    return css(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n    > img {\n      height: 10.4rem;\n    }\n  "])));
  }
};
var cardHeaderModifiers = {
  "default": function _default() {
    return css(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n    flex-wrap: wrap;\n    padding: ", ";\n  "])), spacing.medium);
  },
  toggle: function toggle(color) {
    return css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n    padding: ", ";\n\n    > img {\n      object-fit: cover;\n      object-position: top center;\n    }\n  "])), colors[color], spacing.medium);
  },
  hero: function hero() {
    return css(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose([""])));
  }
};
var wrapperModifiers = {
  "default": function _default(_, color) {
    return css(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n    gap: ", ";\n    background: ", ";\n\n    img {\n      margin: 0 auto;\n      display: block;\n    }\n  "])), spacing.small, colors[color]);
  },
  toggle: function toggle() {
    return css(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n    height: 100%;\n\n    &:after {\n      content: '';\n      width: 100%;\n      height: 60px;\n      background: ", ";\n      opacity: 0.15;\n      margin: 0 auto;\n    }\n  "])), colors.gradient_border_color);
  },
  hero: function hero(image) {
    return css(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n    height: 30rem;\n    position: relative;\n    width: 100%;\n    background: url(", ") no-repeat;\n    background-size: cover;\n    overflow: hidden;\n    justify-content: flex-end;\n    ", "\n  "])), image, shadows.inner);
  }
};
var Wrapper$7 = /*#__PURE__*/styled.div(_templateObject10$5 || (_templateObject10$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    image = _ref.image;
  return css(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 40px;\n    border-radius: ", ";\n\n    ", ";\n  "])), radius.medium, variant && wrapperModifiers[variant](image, color));
});
var CardHeader = /*#__PURE__*/styled.div(_templateObject12$5 || (_templateObject12$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var size = _ref2.size,
    variant = _ref2.variant,
    color = _ref2.color;
  return css(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteralLoose(["\n    padding: ", " ", ";\n    ", ";\n\n    ", ";\n    ", ";\n  "])), spacing.medium, spacing.small, borderRadius('top', radius.medium), !!size && imageSizeModifiers[size](), !!variant && cardHeaderModifiers[variant](color));
});
var CardBodyWrapper = /*#__PURE__*/styled.div(_templateObject14$3 || (_templateObject14$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: ", ";\n  background: ", ";\n"])), spacing.medium, colors.light);
var Description = /*#__PURE__*/styled.div(_templateObject15$2 || (_templateObject15$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n\n  ", "\n"])), /*#__PURE__*/gap(spacing.small));
var CardContent = /*#__PURE__*/styled.div(_templateObject16$2 || (_templateObject16$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /**\n   * TODO: Add transitioning here. Should use other properties for this.\n   */\n  ", "\n"])), function (_ref3) {
  var isHidden = _ref3.isHidden;
  return css(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n    display: ", ";\n    margin-top: ", ";\n  "])), isHidden ? 'none' : 'block', isHidden ? 0 : spacing.medium);
});
var IconWrapper$1 = /*#__PURE__*/styled.button(_templateObject18$2 || (_templateObject18$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var isHidden = _ref4.isHidden;
  return css(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteralLoose(["\n    background-color: transparent;\n    border: none;\n    transform: ", ";\n    transition: transform 0.3s ease-in-out;\n    cursor: pointer;\n    will-change: transform;\n  "])), isHidden ? 'none' : 'rotate(180deg)');
});
var CardBody = /*#__PURE__*/styled.div(_templateObject20$2 || (_templateObject20$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref5) {
  var variant = _ref5.variant;
  return css(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteralLoose(["\n    z-index: 1;\n    padding: ", " ", ";\n\n    ", ";\n  "])), spacing.small, spacing.medium, variant === 'default' && borderRadius('bottom', radius.medium));
});
var Buttons = /*#__PURE__*/styled.div(_templateObject22$2 || (_templateObject22$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  z-index: 1;\n  padding: ", " 0;\n  justify-content: space-around;\n"])), spacing.small);

var Body = function Body(_ref) {
  var children = _ref.children,
    _ref$hideContent = _ref.hideContent,
    hideContent = _ref$hideContent === void 0 ? true : _ref$hideContent,
    description = _ref.description,
    variant = _ref.variant;
  var _useState = useState(hideContent),
    isHidden = _useState[0],
    setIsHidden = _useState[1];
  if (variant === 'toggle') {
    return React.createElement(CardBodyWrapper, null, React.createElement(Description, null, description, React.createElement(IconWrapper$1, {
      isHidden: isHidden,
      onClick: function onClick() {
        return setIsHidden(!isHidden);
      },
      "aria-label": (isHidden ? 'open' : 'close') + " menu"
    }, React.createElement(ArrowDown, {
      color: "dark",
      size: 16
    }))), React.createElement(CardContent, {
      isHidden: isHidden
    }, children));
  }
  return React.createElement(CardBody, {
    variant: variant
  }, children);
};

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return React.createElement(Buttons, null, children);
};

var _excluded$6 = ["size", "children", "variant", "colors"];
var Header$2 = function Header(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    children = _ref.children,
    variant = _ref.variant,
    colors = _ref.colors,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  return React.createElement(CardHeader, _extends({
    color: colors,
    variant: variant,
    size: size
  }, rest), children);
};

var _excluded$5 = ["children", "image", "isExpanded", "variant", "color", "align"];
var Card$1 = function Card(_ref) {
  var children = _ref.children,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'gradient__primary' : _ref$color,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  return React.createElement(Wrapper$7, _extends({
    color: color,
    image: image,
    variant: variant,
    isExpanded: isExpanded,
    align: align
  }, rest), children);
};
Card$1.Header = Header$2;
Card$1.Body = Body;
Card$1.Footer = Footer;

var _templateObject$b, _templateObject2$b, _templateObject3$9, _templateObject4$9, _templateObject5$8, _templateObject6$7, _templateObject7$6, _templateObject8$5, _templateObject9$5, _templateObject10$4, _templateObject11$4, _templateObject12$4, _templateObject13$4, _templateObject14$2;
var sliderControlSize = '4rem';
var baseSliderControlButton = function baseSliderControlButton(_ref) {
  var _ref$controlsColor = _ref.controlsColor,
    controlsColor = _ref$controlsColor === void 0 ? 'secondary' : _ref$controlsColor,
    _ref$invertArrow = _ref.invertArrow,
    invertArrow = _ref$invertArrow === void 0 ? false : _ref$invertArrow;
  return css(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n  opacity: 0;\n\n  ", ";\n"])), media.greaterThan('tablet')(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n    visibility: visible;\n    opacity: ", ";\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    background-color: ", ";\n    transition: opacity ease-in-out 300ms;\n    position: relative;\n\n    & svg {\n      transform: ", ";\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      inset: 0;\n      border-radius: 50%;\n      padding: ", ";\n      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n      -webkit-mask: linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: destination-out;\n      mask-composite: exclude;\n      pointer-events: none;\n      background: ", ";\n    }\n  "])), opacity.light, sliderControlSize, sliderControlSize, colors.neutral_extra_light, invertArrow ? 'rotate(90deg)' : 'rotate(-90deg)', borderWidths.small, colors[controlsColor]));
};
var SliderPrevButton = /*#__PURE__*/styled.button(_templateObject3$9 || (_templateObject3$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var controlsColor = _ref2.controlsColor;
  return css(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), baseSliderControlButton({
    controlsColor: controlsColor,
    invertArrow: true
  }));
});
var SliderNextButton = /*#__PURE__*/styled.button(_templateObject5$8 || (_templateObject5$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var controlsColor = _ref3.controlsColor;
  return css(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), baseSliderControlButton({
    controlsColor: controlsColor
  }));
});
var NukaCarousel$1 = /*#__PURE__*/styled(Carousel$1)(_templateObject7$6 || (_templateObject7$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref4) {
  var _ref4$cellSpacing = _ref4.cellSpacing,
    cellSpacing = _ref4$cellSpacing === void 0 ? 0 : _ref4$cellSpacing;
  return css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["\n    width: calc(100% + ", ") !important;\n    margin-left: calc(-", " / 2);\n\n    &:hover ", ", &:hover ", " {\n      opacity: 1;\n    }\n\n    .slider-slide {\n      outline: 0 !important;\n    }\n  "])), rem(cellSpacing, 10), rem(cellSpacing, 10), SliderPrevButton, SliderNextButton);
});
var Wrapper$6 = /*#__PURE__*/styled.div(_templateObject9$5 || (_templateObject9$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  .slider-control-bottomcenter {\n    width: 100%;\n    bottom: unset;\n    top: calc(100% + ", ");\n  }\n\n  .slider-control-centerright {\n    position: absolute;\n    right: calc(-", " / 2) !important;\n  }\n\n  .slider-control-centerleft {\n    position: absolute;\n    left: calc(-", " / 2) !important;\n  }\n"])), gutter["default"], sliderControlSize, sliderControlSize);
var NavigationControlContainer = /*#__PURE__*/styled.div(_templateObject10$4 || (_templateObject10$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  width: calc(100% - ", ");\n  position: absolute;\n  bottom: -", ";\n  left: 0;\n  display: flex;\n\n  ", ";\n\n  ", "\n"])), spacing.medium, spacing.medium, /*#__PURE__*/gap(gutter.small), /*#__PURE__*/media.greaterThan('tablet')(_templateObject11$4 || (_templateObject11$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    width: 100%;\n  "]))));
var NavigationControl = /*#__PURE__*/styled.button(_templateObject12$4 || (_templateObject12$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref5) {
  var _ref5$controlsColor = _ref5.controlsColor,
    controlsColor = _ref5$controlsColor === void 0 ? 'secondary' : _ref5$controlsColor;
  return css(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteralLoose(["\n    height: 0.4rem;\n    background-color: ", ";\n    border-radius: ", ";\n    width: 100%;\n    border: 0;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity 0.5s ease;\n    will-change: opacity;\n\n    ", "\n\n    &:disabled {\n      opacity: 1;\n      cursor: default;\n    }\n  "])), colors[controlsColor], radius.small, opacity.hard, media.greaterThan('tablet')(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n      height: 0.6rem;\n    "]))));
});

var Controls = function Controls(_ref) {
  var slideCount = _ref.slideCount,
    currentSlide = _ref.currentSlide,
    goToSlide = _ref.goToSlide,
    _ref$controlsColor = _ref.controlsColor,
    controlsColor = _ref$controlsColor === void 0 ? 'secondary' : _ref$controlsColor;
  var _useViewport = useViewport(),
    greaterThan = _useViewport.greaterThan;
  /**
   * NOTE: Control length of control mapper when there is 3 items or less and
   * when there is more than 3 items
   */
  var slidesThreshold = function slidesThreshold(slideCount) {
    if (slideCount <= 3) {
      return 1;
    }
    return slideCount - 2;
  };
  /**
   * Control how many controls should be rendered based on
   * visible slides count.
   */
  var ControlMapperLength = greaterThan('tablet') ? slidesThreshold(slideCount) : slideCount;
  return React.createElement(NavigationControlContainer, null, Array.from(Array(ControlMapperLength).keys()).map(function (item) {
    return React.createElement(NavigationControl, {
      "aria-label": "bottom controls",
      key: item,
      disabled: item === Math.ceil(currentSlide),
      onClick: function onClick() {
        return goToSlide(item);
      },
      controlsColor: controlsColor
    });
  }));
};
var Carousel = function Carousel(_ref2) {
  var _ref2$controlsColor = _ref2.controlsColor,
    controlsColor = _ref2$controlsColor === void 0 ? 'secondary' : _ref2$controlsColor,
    children = _ref2.children;
  var _useViewport2 = useViewport(),
    greaterThan = _useViewport2.greaterThan,
    lessThan = _useViewport2.lessThan;
  return (
    /**
     * Proxy for Nuka Carousel with basic setup.
     * @see {@link https://github.com/FormidableLabs/nuka-carousel#props}
     */
    React.createElement(Wrapper$6, null, React.createElement(NukaCarousel$1, {
      scrollMode: ScrollMode.remainder,
      dragThreshold: 0.1,
      renderBottomCenterControls: function renderBottomCenterControls(props) {
        return React.createElement(Controls, _extends({
          controlsColor: controlsColor
        }, props));
      },
      renderCenterLeftControls: function renderCenterLeftControls(_ref3) {
        var previousSlide = _ref3.previousSlide,
          currentSlide = _ref3.currentSlide;
        if (currentSlide !== 0) {
          return React.createElement(MediaMatch, {
            greaterThan: "tablet"
          }, React.createElement(SliderPrevButton, {
            controlsColor: controlsColor,
            "aria-label": "previous slide",
            onClick: previousSlide
          }, React.createElement(ArrowDown, {
            color: controlsColor,
            width: 30,
            height: 30
          })));
        }
        return;
      },
      renderCenterRightControls: function renderCenterRightControls(_ref4) {
        var nextSlide = _ref4.nextSlide,
          currentSlide = _ref4.currentSlide,
          slidesToShow = _ref4.slidesToShow,
          slideCount = _ref4.slideCount;
        var shouldShowNextButton = slideCount > slidesToShow && currentSlide !== slideCount - slidesToShow;
        if (shouldShowNextButton) {
          return React.createElement(MediaMatch, {
            greaterThan: "tablet"
          }, React.createElement(SliderNextButton, {
            controlsColor: controlsColor,
            "aria-label": "next slide",
            onClick: nextSlide
          }, React.createElement(ArrowDown, {
            color: controlsColor,
            width: 30,
            height: 30
          })));
        }
        return;
      },
      cellSpacing: 20,
      slidesToShow: greaterThan('tablet') ? 3 : 1.25,
      dragging: lessThan('tablet')
    }, children))
  );
};

var _templateObject$a, _templateObject2$a, _templateObject3$8, _templateObject4$8, _templateObject5$7, _templateObject6$6, _templateObject7$5, _templateObject8$4, _templateObject9$4, _templateObject10$3, _templateObject11$3, _templateObject12$3, _templateObject13$3, _templateObject14$1, _templateObject15$1, _templateObject16$1, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29;
var controlHeight = '0.6rem';
var controlWidth = '0.6rem';
var SideContentWrapper = /*#__PURE__*/styled.div(_templateObject$a || (_templateObject$a = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-areas: 'side';\n"])));
var transitionModifier = {
  "default": function _default(visible) {
    return css(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n    opacity: ", ";\n    transition: opacity linear 0.5s;\n\n    ", "\n  "])), opacity.medium, visible && css(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n      visibility: visible;\n      opacity: 1;\n      transition: opacity linear 0.5s;\n    "]))));
  },
  none: function none(visible) {
    return css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), visible && css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n      visibility: visible;\n    "]))));
  }
};
var SideContent = /*#__PURE__*/styled.div(_templateObject6$6 || (_templateObject6$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-area: side;\n  visibility: hidden;\n\n  ", "\n"])), function (_ref) {
  var visible = _ref.visible,
    transitionVariant = _ref.transitionVariant;
  return transitionModifier[transitionVariant](visible);
});
/**
 * NOTE: This is a modifier to override the default styles of the Carousel component from nuka-carousel.
 * We need to do this because the Carousel behaves differently when slidesToShow is an integer or not.
 */
var widthAndPositionModifier = function widthAndPositionModifier(slidesToShow, cellSpacing) {
  if (Number.isInteger(slidesToShow)) {
    var extraWidth = "" + rem(cellSpacing, 10);
    return css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n      width: calc(100% + ", ") !important;\n      margin-left: calc(-", " / 2);\n    "])), extraWidth, extraWidth);
  }
  return css(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n    & .slider-list {\n      & .slide.slide-visible:first-child {\n        padding-left: 0 !important;\n      }\n\n      & .slide.slide-visible:last-child {\n        padding-right: 0 !important;\n      }\n    }\n  "])));
};
var NukaCarousel = /*#__PURE__*/styled(Carousel$1)(_templateObject9$4 || (_templateObject9$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var _ref2$slidesToShow = _ref2.slidesToShow,
    slidesToShow = _ref2$slidesToShow === void 0 ? 1 : _ref2$slidesToShow,
    _ref2$cellSpacing = _ref2.cellSpacing,
    cellSpacing = _ref2$cellSpacing === void 0 ? 0 : _ref2$cellSpacing;
  return css(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n    grid-area: carousel;\n    cursor: pointer;\n    user-select: none;\n    position: relative;\n\n    ", "\n  "])), widthAndPositionModifier(slidesToShow, cellSpacing));
});
var IconButton = /*#__PURE__*/styled.button(_templateObject11$3 || (_templateObject11$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border: none;\n\n  &:disabled {\n    background-color: ", ";\n    opacity: ", ";\n    cursor: not-allowed;\n  }\n"])), colors.dark, colors.neutral, opacity.hard);
var controlSize = function controlSize(size) {
  return css(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n\n    width: calc(", " / 1.2);\n    height: calc(", " / 1.2);\n  }\n"])), size, size, size, size);
};
var BackControl = /*#__PURE__*/styled(IconButton)(_templateObject13$3 || (_templateObject13$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var arrowSize = _ref3.arrowSize;
  return arrowSize && controlSize(arrowSize);
});
var ForwardControl = /*#__PURE__*/styled(IconButton)(_templateObject14$1 || (_templateObject14$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var arrowSize = _ref4.arrowSize;
  return arrowSize && controlSize(arrowSize);
});
var LeftArrowIcon = /*#__PURE__*/styled(ArrowDown)(_templateObject15$1 || (_templateObject15$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  transform: translate(-50%, -50%) rotate(90deg);\n"])));
var RightArrowIcon = /*#__PURE__*/styled(ArrowDown)(_templateObject16$1 || (_templateObject16$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  transform: translate(-50%, -50%) rotate(270deg);\n"])));
var SecondaryContentWrapper = /*#__PURE__*/styled.div(_templateObject18$1 || (_templateObject18$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-areas: 'secondary';\n"])));
var SecondaryContent = /*#__PURE__*/styled.div(_templateObject19$1 || (_templateObject19$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  grid-area: secondary;\n  visibility: hidden;\n\n  ", "\n"])), function (_ref5) {
  var visible = _ref5.visible,
    transitionVariant = _ref5.transitionVariant;
  return transitionModifier[transitionVariant](visible);
});
var variantsModifier = {
  centeredControls: function centeredControls(_ref6) {
    var arrowSize = _ref6.arrowSize;
    return css(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteralLoose(["\n    ", " {\n      width: calc(100% - (", " + ", ")) !important;\n      margin: 0 auto;\n    }\n\n    .slider-control-centerright,\n    .slider-control-centerleft {\n      top: 50% !important;\n      transform: translateY(-50%);\n      bottom: unset !important;\n    }\n  "])), NukaCarousel, arrowSize, spacing.medium);
  },
  additionalContent: function additionalContent(_ref7) {
    var arrowSize = _ref7.arrowSize;
    return css(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteralLoose(["\n    ", " {\n      margin-top: calc(", " + ", ");\n    }\n\n    margin-bottom: calc(", " + ", ");\n  "])), SecondaryContent, arrowSize, spacing.medium, spacing.small, arrowSize);
  },
  twoColumns: function twoColumns(_ref8) {
    var bulletsWidth = _ref8.bulletsWidth,
      arrowSize = _ref8.arrowSize;
    return css(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteralLoose(["\n    display: grid;\n    // NOTE: this 31rem value is the fixed defined value on figma for the side content\n    grid-template-columns: minmax(0, 31rem) minmax(0, 1fr);\n    gap: ", ";\n\n    .slider-control-centerright,\n    .slider-control-centerleft {\n      transform: unset !important;\n    }\n\n    ", " {\n      margin-top: calc(", " + ", ");\n    }\n\n    ", "\n\n    ", " {\n      grid-template-areas:\n        'carousel carousel carousel'\n        'additional additional additional';\n      grid-template-rows: auto auto;\n      grid-template-columns: 1fr;\n    }\n\n    .slider-control-centerleft {\n      float: left;\n      margin-right: ", ";\n      left: unset !important;\n    }\n\n    .slider-control-centerright {\n      right: unset !important;\n      left: calc(\n        ", "rem + calc(", " + ", " * 2)\n      );\n    }\n\n    .slider-control-bottomcenter {\n      transform: unset !important;\n      left: calc(", " + ", ") !important;\n      float: left;\n    }\n\n    ", " {\n      grid-area: additional;\n      margin-top: ", ";\n    }\n  "])), spacing.large, SecondaryContent, arrowSize, spacing.medium, media.lessThan('tablet')(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n      // NOTE: this 31rem value is the fixed defined value on figma for the side content on smaller screens\n      grid-template-columns: minmax(0, 21rem) minmax(0, 1fr);\n      gap: ", ";\n    "])), spacing.medium), MainContentWrapper, spacing.medium, bulletsWidth, arrowSize, spacing.medium, arrowSize, spacing.medium, SecondaryContentWrapper, spacing.medium);
  }
};
var CarouselContainer = /*#__PURE__*/styled.div(_templateObject24 || (_templateObject24 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref9) {
  var variant = _ref9.variant,
    bulletsWidth = _ref9.bulletsWidth,
    arrowSize = _ref9.arrowSize;
  return css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n    .slider-control-centerleft,\n    .slider-control-centerright {\n      position: absolute;\n      top: unset !important;\n      bottom: calc((", " + ", ") * -1) !important;\n    }\n\n    .slider-container {\n      .slider-control-bottomright {\n        margin-right: ", ";\n\n        ", "\n      }\n\n      .slider-control-bottomleft {\n        margin-top: ", ";\n      }\n    }\n\n    .slider-control-bottomcenter {\n      position: absolute;\n      bottom: calc((", " + ", ") * -1) !important;\n\n      & ul {\n        top: 0 !important;\n        display: flex;\n        height: ", ";\n        align-items: center;\n\n        .paging-item {\n          display: flex;\n\n          svg {\n            display: none;\n          }\n\n          button {\n            width: ", ";\n            height: ", ";\n            border-radius: 50%;\n            transition: width 0.3s ease, border-radius, 0.2s ease;\n          }\n\n          &:not(:last-child) {\n            margin-right: ", ";\n          }\n\n          &.active button {\n            width: 1.8rem;\n            border-radius: ", ";\n          }\n        }\n      }\n    }\n\n    ", "\n\n    & * {\n      outline: none;\n      -webkit-tap-highlight-color: transparent;\n    }\n  "])), arrowSize, spacing.small, spacing.medium, media.greaterThan('tablet')(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["\n          margin-right: 0;\n        "]))), spacing.small, arrowSize, spacing.small, arrowSize, controlWidth, controlHeight, controlWidth, radius.large, variant && variantsModifier[variant]({
    bulletsWidth: bulletsWidth,
    arrowSize: arrowSize
  }));
});
var mainContentWrapperModifiers = function mainContentWrapperModifiers(theme) {
  var background = theme === 'dark' ? colors.dark : colors.light;
  var color = theme === 'dark' ? colors.light : colors.dark;
  return css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["\n    ", " {\n      background-color: ", ";\n    }\n\n    ", " {\n      background-color: ", ";\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    ", " {\n      color: ", ";\n    }\n\n    .slider-control-bottomcenter {\n      & ul {\n        .paging-item {\n          button {\n            background-color: ", " !important;\n          }\n        }\n      }\n    }\n  "])), BackControl, background, ForwardControl, background, LeftArrowIcon, color, RightArrowIcon, color, background);
};
var MainContentWrapper = /*#__PURE__*/styled.div(_templateObject28 || (_templateObject28 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), mainContentWrapperModifiers(theme));
});

var _excluded$4 = ["variant", "sideContent", "sideContentTransition", "secondaryContent", "secondaryContentTransition", "controlsTheme", "slidesToShow", "slidesToScroll", "cellSpacing", "children", "arrowSize"];
var BulletCarousel = function BulletCarousel(_ref) {
  var variant = _ref.variant,
    sideContent = _ref.sideContent,
    _ref$sideContentTrans = _ref.sideContentTransition,
    sideContentTransition = _ref$sideContentTrans === void 0 ? 'default' : _ref$sideContentTrans,
    secondaryContent = _ref.secondaryContent,
    _ref$secondaryContent = _ref.secondaryContentTransition,
    secondaryContentTransition = _ref$secondaryContent === void 0 ? 'default' : _ref$secondaryContent,
    _ref$controlsTheme = _ref.controlsTheme,
    controlsTheme = _ref$controlsTheme === void 0 ? 'dark' : _ref$controlsTheme,
    _ref$slidesToShow = _ref.slidesToShow,
    slidesToShow = _ref$slidesToShow === void 0 ? 1 : _ref$slidesToShow,
    _ref$slidesToScroll = _ref.slidesToScroll,
    slidesToScroll = _ref$slidesToScroll === void 0 ? 1 : _ref$slidesToScroll,
    cellSpacing = _ref.cellSpacing,
    children = _ref.children,
    _ref$arrowSize = _ref.arrowSize,
    arrowSize = _ref$arrowSize === void 0 ? '1.8rem' : _ref$arrowSize,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var _useState = useState(0),
    slideIndex = _useState[0],
    setSlideIndex = _useState[1];
  var _useState2 = useState(0),
    bulletsWidth = _useState2[0],
    setBulletsWidth = _useState2[1];
  /* NOTE: the use of Math.ceil here is necessary because if the result is a decimal
  it should be rounded up to match the actual number of bullets
  */
  var numberOfBullets = Math.ceil((children.length - (slidesToShow - slidesToScroll)) / slidesToScroll);
  useEffect(function () {
    /* NOTE: here the numberOfBullets is being multiplied by 1.2rem
    which is the width of the bullet and the margin-right,
    and the + 0.6 at the end is to compensate for the active bullet width which is 1.8rem
    */
    setBulletsWidth(1.2 * numberOfBullets + 0.6);
  }, [setBulletsWidth, numberOfBullets]);
  return React.createElement(CarouselContainer, {
    arrowSize: arrowSize,
    variant: variant,
    bulletsWidth: bulletsWidth
  }, !!(sideContent != null && sideContent.length) && variant === 'twoColumns' && React.createElement(SideContentWrapper, null, sideContent.map(function (content, index) {
    return React.createElement(SideContent, {
      key: "content" + index,
      visible: slideIndex === index,
      transitionVariant: sideContentTransition
    }, content);
  })), React.createElement(MainContentWrapper, {
    theme: controlsTheme
  }, React.createElement(NukaCarousel, _extends({
    scrollMode: ScrollMode.remainder,
    dragThreshold: 0.1,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    slideIndex: slideIndex,
    cellSpacing: cellSpacing,
    renderCenterLeftControls: function renderCenterLeftControls(_ref2) {
      var currentSlide = _ref2.currentSlide,
        previousSlide = _ref2.previousSlide;
      return React.createElement(BackControl, {
        disabled: currentSlide === 0,
        onClick: function onClick() {
          return previousSlide();
        },
        arrowSize: arrowSize
      }, React.createElement(LeftArrowIcon, null));
    },
    renderCenterRightControls: function renderCenterRightControls(_ref3) {
      var nextSlide = _ref3.nextSlide,
        currentSlide = _ref3.currentSlide,
        slideCount = _ref3.slideCount,
        slidesToShow = _ref3.slidesToShow;
      return React.createElement(ForwardControl, {
        disabled: currentSlide + slidesToShow >= slideCount,
        onClick: function onClick() {
          return nextSlide();
        },
        arrowSize: arrowSize
      }, React.createElement(RightArrowIcon, null));
    },
    beforeSlide: function beforeSlide(_currentIndex, nextIndex) {
      setSlideIndex(nextIndex);
    }
  }, rest), children), !!(secondaryContent != null && secondaryContent.length) && (variant === 'additionalContent' || variant === 'twoColumns') && React.createElement(SecondaryContentWrapper, null, secondaryContent.map(function (content, index) {
    return React.createElement(SecondaryContent, {
      key: "content" + index,
      visible: slideIndex === index,
      transitionVariant: secondaryContentTransition
    }, content);
  }))));
};

var _templateObject$9, _templateObject2$9;
var rotationHelper = function rotationHelper(side) {
  switch (side) {
    case 'below':
      return 'rotate(0);';
    case 'above':
      return 'rotate(180deg);';
    default:
      return 'rotate(0);';
  }
};
var Wrapper$5 = /*#__PURE__*/styled.hr(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var position = _ref.position;
  return css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  border: 0;\n\n  &::after {\n    transform: ", "\n    display: block;\n    height: 8rem;\n    content: '';\n    background-image: ", ";\n    opacity: 0.15;\n  }\n  "])), rotationHelper(position), colors.gradient_border_color);
});

var _excluded$3 = ["position"];
var Divider = function Divider(_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'below' : _ref$position,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  return React.createElement(Wrapper$5, _extends({
    position: position
  }, props));
};

var _templateObject$8, _templateObject2$8, _templateObject3$7, _templateObject4$7, _templateObject5$6, _templateObject6$5, _templateObject7$4, _templateObject8$3, _templateObject9$3, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2;
var drawerModifier = function drawerModifier(_ref) {
  var variant = _ref.variant,
    contentMaxWidth = _ref.contentMaxWidth;
  if (variant === 'centralize') {
    var size = {
      "default": '35rem',
      large: '60rem'
    };
    return css(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n      display: flex;\n      justify-content: center;\n\n      ", " {\n        width: 100%;\n        margin: 0 ", ";\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        max-width: ", ";\n      }\n\n      ", " {\n        width: 100%;\n      }\n\n      ", " {\n        padding: ", ";\n      }\n    "])), Wrapper$4, spacing.medium, size[contentMaxWidth], Header$1, ContentWrapper, spacing.none);
  }
  return css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n    ", " {\n      padding: 0 ", ";\n    }\n  "])), Header$1, spacing.medium);
};
var Wrapper$4 = /*#__PURE__*/styled.div(_templateObject3$7 || (_templateObject3$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  height: 100%;\n"])));
var ContentWrapper = /*#__PURE__*/styled(Grid.Wrapper)(_templateObject4$7 || (_templateObject4$7 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var DrawerContainer = /*#__PURE__*/styled.div(_templateObject5$6 || (_templateObject5$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var _ref2$paddingBottom = _ref2.paddingBottom,
    paddingBottom = _ref2$paddingBottom === void 0 ? 'medium' : _ref2$paddingBottom,
    _ref2$paddingTop = _ref2.paddingTop,
    paddingTop = _ref2$paddingTop === void 0 ? 'medium' : _ref2$paddingTop,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'full' : _ref2$variant,
    topOffset = _ref2.topOffset,
    _ref2$contentMaxWidth = _ref2.contentMaxWidth,
    contentMaxWidth = _ref2$contentMaxWidth === void 0 ? 'default' : _ref2$contentMaxWidth;
  return css(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    position: absolute;\n    left: 0;\n    bottom: -100%;\n    border-radius: ", " ", " 0 0;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    background-color: ", ";\n    transition: bottom ", ";\n    overflow-y: auto;\n\n    ", "\n\n    ", "\n  "])), radius.medium, radius.medium, spacing[paddingTop], spacing[paddingBottom], colors.light, transitions.easeInAndOutBack, !!topOffset && css(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n      max-height: calc(100% - ", ");\n    "])), topOffset), drawerModifier({
    variant: variant,
    contentMaxWidth: contentMaxWidth
  }));
});
var DrawerBackdrop = /*#__PURE__*/styled.div(_templateObject8$3 || (_templateObject8$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var open = _ref3.open;
  return css(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    position: fixed;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    pointer-events: none;\n    opacity: 0;\n    visibility: hidden;\n    z-index: ", ";\n    transition: opacity 0.45s, visibility 0.45s ease;\n\n    ", "\n  "])), rgba(colors.dark, opacity.hard), layers.alert, !!open && css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n      opacity: 1;\n      visibility: visible;\n      pointer-events: initial;\n      transition: opacity 0.45s, visibility 0.45s ease;\n\n      ", " {\n        bottom: 0;\n        transition: bottom ", ";\n\n        &::after {\n          content: '';\n          position: fixed;\n          left: 0;\n          bottom: 0;\n          height: 1.2rem;\n          background-color: ", ";\n          width: 100%;\n        }\n      }\n    "])), DrawerContainer, transitions.easeInAndOutBack, colors.light));
});
var closeButtonPosition = {
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center'
};
var Header$1 = /*#__PURE__*/styled.div(_templateObject11$2 || (_templateObject11$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var _ref4$closeButtonPosi = _ref4.closeButtonPositionY,
    closeButtonPositionY = _ref4$closeButtonPosi === void 0 ? 'center' : _ref4$closeButtonPosi,
    _ref4$titleMarginBott = _ref4.titleMarginBottom,
    titleMarginBottom = _ref4$titleMarginBott === void 0 ? 'small' : _ref4$titleMarginBott;
  return css(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: ", ";\n    justify-content: flex-end;\n    margin-bottom: ", ";\n  "])), closeButtonPosition[closeButtonPositionY], spacing[titleMarginBottom]);
});
var CloseButton$1 = /*#__PURE__*/styled.button(_templateObject13$2 || (_templateObject13$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"])));

var Drawer = function Drawer(_ref) {
  var title = _ref.title,
    _ref$closeButtonColor = _ref.closeButtonColor,
    closeButtonColor = _ref$closeButtonColor === void 0 ? 'secondary' : _ref$closeButtonColor,
    closeButtonPositionY = _ref.closeButtonPositionY,
    open = _ref.open,
    children = _ref.children,
    _ref$dismissible = _ref.dismissible,
    dismissible = _ref$dismissible === void 0 ? true : _ref$dismissible,
    paddingTop = _ref.paddingTop,
    paddingBottom = _ref.paddingBottom,
    _ref$titleMarginBotto = _ref.titleMarginBottom,
    titleMarginBottom = _ref$titleMarginBotto === void 0 ? 'small' : _ref$titleMarginBotto,
    onClose = _ref.onClose,
    topOffset = _ref.topOffset,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'full' : _ref$variant,
    _ref$closeIconSize = _ref.closeIconSize,
    closeIconSize = _ref$closeIconSize === void 0 ? 24 : _ref$closeIconSize,
    _ref$contentMaxWidth = _ref.contentMaxWidth,
    contentMaxWidth = _ref$contentMaxWidth === void 0 ? 'default' : _ref$contentMaxWidth;
  var backdropRef = useRef(null);
  var drawerRef = useRef(null);
  useEffect(function () {
    var backdrop = backdropRef.current;
    var handleClose = function handleClose(_ref2) {
      var key = _ref2.key;
      if (key === 'Escape') {
        onClose();
      }
    };
    var handleClick = function handleClick(_ref3) {
      var _drawerRef$current;
      var target = _ref3.target;
      return !(drawerRef != null && (_drawerRef$current = drawerRef.current) != null && _drawerRef$current.contains(target)) && onClose();
    };
    if (dismissible) {
      window.addEventListener('keydown', handleClose, false);
      backdrop == null || backdrop.addEventListener('click', handleClick, false);
    }
    return function () {
      window.removeEventListener('keydown', handleClose, false);
      backdrop == null || backdrop.removeEventListener('click', handleClick, false);
    };
  }, [dismissible, onClose]);
  return React.createElement(DrawerBackdrop, {
    ref: backdropRef,
    "aria-label": "sfondo della finestra di dialogo",
    "aria-hidden": !open,
    open: open
  }, React.createElement(DrawerContainer, {
    ref: drawerRef,
    paddingTop: paddingTop,
    paddingBottom: paddingBottom,
    variant: variant,
    topOffset: topOffset,
    contentMaxWidth: contentMaxWidth
  }, React.createElement(Wrapper$4, null, dismissible && React.createElement(Header$1, {
    closeButtonPositionY: closeButtonPositionY,
    titleMarginBottom: titleMarginBottom
  }, title, React.createElement(CloseButton$1, {
    onClick: onClose,
    "aria-label": "chiudi la finestra di dialogo"
  }, React.createElement(CloseCircle, {
    width: closeIconSize,
    height: closeIconSize,
    color: closeButtonColor
  }))), React.createElement(ContentWrapper, null, children))));
};

var _templateObject$7, _templateObject2$7, _templateObject3$6, _templateObject4$6, _templateObject5$5, _templateObject6$4, _templateObject7$3, _templateObject8$2, _templateObject9$2, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
var calc = "calc(0.75rem + " + gutter["default"] + ")";
var transformHelpers = {
  up: "translate(" + calc + ", -0.9rem) scale(0.75)",
  down: "translate(2rem, 0.8rem) scale(1)",
  legendMaxWidth: "max-width: 100%",
  legendPadding: "padding: 0 0.75rem"
};
var labelTransformModifiers = {
  moveUp: /*#__PURE__*/css(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    transform: ", ";\n  "])), transformHelpers.up),
  moveDown: /*#__PURE__*/css(_templateObject2$7 || (_templateObject2$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    transform: ", ";\n  "])), transformHelpers.down),
  legendVisible: /*#__PURE__*/css(_templateObject3$6 || (_templateObject3$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n  "])), transformHelpers.legendMaxWidth, transformHelpers.legendPadding)
};
var WrapperModifiers = {
  dark: function dark() {
    return css(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n    ", " {\n      color: ", ";\n\n      & + ", " {\n        color: ", ";\n      }\n\n      &:focus + ", " {\n        color: ", ";\n      }\n    }\n\n    ", " {\n      border: ", " solid ", ";\n    }\n\n    ", " {\n      > svg {\n        fill: ", ";\n      }\n    }\n  "])), Input$1, colors.text__primary, Label$2, colors.text__primary, Label$2, colors.text__primary, Fieldset, borderWidths.thin, colors.dark, Icon, colors.dark);
  },
  primary: function primary(hasValue) {
    return css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n    ", " {\n      color: ", ";\n\n      & + ", " {\n        color: ", ";\n      }\n\n      &:focus + ", " {\n        color: ", ";\n      }\n    }\n\n    ", " {\n      border: ", " solid ", ";\n    }\n  "])), Input$1, colors.text__primary, Label$2, hasValue ? colors.text__primary : colors.primary, Label$2, colors.text__primary, Fieldset, borderWidths.thin, colors.primary);
  },
  secondary: function secondary(hasValue) {
    return css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n    ", " {\n      color: ", ";\n\n      & + ", " {\n        color: ", ";\n      }\n\n      &:focus + ", " {\n        color: ", ";\n      }\n    }\n\n    ", " {\n      border: ", " solid ", ";\n    }\n\n    ", " {\n      > svg {\n        color: ", ";\n      }\n    }\n  "])), Input$1, colors.text__primary, Label$2, hasValue ? colors.text__primary : colors.secondary, Label$2, colors.text__primary, Fieldset, borderWidths.thin, colors.secondary, Icon, colors.secondary);
  },
  error: function error() {
    return css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n    ", " {\n      color: ", ";\n    }\n\n    ", ",\n    ", " {\n      color: ", ";\n    }\n\n    ", " {\n      border: ", " solid ", ";\n    }\n\n    ", " {\n      > svg {\n        fill: ", ";\n      }\n    }\n  "])), Input$1, colors.text__primary, Label$2, Text, colors.state__error, Fieldset, borderWidths.thin, colors.state__error, Icon, colors.state__error);
  },
  success: function success() {
    return css(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n    ", " {\n      color: ", ";\n    }\n\n    ", ",\n    ", " {\n      color: ", ";\n    }\n    ", " {\n      border: ", " solid ", ";\n    }\n\n    ", " {\n      > svg {\n        fill: ", ";\n      }\n    }\n  "])), Input$1, colors.text__primary, Label$2, Text, colors.state__success, Fieldset, borderWidths.thin, colors.state__success, Icon, colors.state__success);
  }
};
var Wrapper$3 = /*#__PURE__*/styled.div(_templateObject9$2 || (_templateObject9$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    hasValue = _ref.hasValue;
  return css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    position: relative;\n\n    ", " {\n      color: ", ";\n    }\n\n    ", "\n  "])), Text, colors.text__primary, !!variant && WrapperModifiers[variant](hasValue));
});
var Card = /*#__PURE__*/styled.div(_templateObject11$1 || (_templateObject11$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  width: 100%;\n  position: relative;\n  cursor: text;\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  border-radius: ", ";\n  align-items: center;\n"])), spacing.small);
var Fieldset = /*#__PURE__*/styled.fieldset(_templateObject12$1 || (_templateObject12$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-align: left;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  top: -5px;\n  left: 0;\n  padding: 0 ", ";\n  pointer-events: none;\n  border-radius: inherit;\n"])), gutter["default"]);
var Input$1 = /*#__PURE__*/styled.input(_templateObject13$1 || (_templateObject13$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var hasValue = _ref2.hasValue,
    _ref2$textTransform = _ref2.textTransform,
    textTransform = _ref2$textTransform === void 0 ? 'none' : _ref2$textTransform,
    hasLabel = _ref2.hasLabel;
  return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n    background: none;\n    border: 0;\n    box-sizing: content-box;\n    margin: 0;\n    outline: 0;\n    padding: ", " ", ";\n    resize: none;\n    width: 100%;\n    text-transform: ", ";\n\n    ", "\n\n    ", "\n\n    & + ", " {\n      transform: ", ";\n    }\n\n    ", "\n\n    & ~ ", " ", " {\n      ", "\n    }\n\n    &:focus + ", " {\n      ", "\n    }\n\n    &:focus ~ ", " ", " {\n      ", "\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      color: ", ";\n\n      & ~ ", " {\n        border-color: ", ";\n      }\n\n      & + ", " {\n        color: ", ";\n      }\n    }\n\n    &:read-only {\n      cursor: not-allowed;\n      color: ", ";\n\n      & ~ ", " {\n        border-color: ", ";\n      }\n\n      & + ", " {\n        color: ", ";\n      }\n    }\n\n    &:read-only:focus + ", " {\n      color: ", ";\n    }\n\n    &[type='time'] {\n      & + ", " {\n        ", "\n      }\n\n      & ~ ", " ", " {\n        ", "\n      }\n    }\n\n    &[type='email'] {\n      text-transform: lowercase;\n    }\n\n    &:-webkit-autofill,\n    &:-webkit-autofill:hover,\n    &:-webkit-autofill:focus,\n    &:-webkit-autofill:active {\n      transition: background-color 600000s ease-in-out 0s,\n        color 600000s ease-in-out 0s;\n      -webkit-box-shadow: 0 0 0px 1000px ", " inset;\n    }\n  "])), spacing.small, spacing.medium, textTransform, typography.body_text_1, !hasLabel && css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n      background: ", ";\n      border-radius: ", ";\n    "])), colors.light, radius.small), Label$2, hasValue ? transformHelpers.up : transformHelpers.down, !hasLabel && css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n      & ~ ", " {\n        top: -2px;\n      }\n    "])), Fieldset), Fieldset, Legend, hasLabel && css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n        ", ";\n        ", ";\n      "])), hasValue ? transformHelpers.legendMaxWidth : 'max-width: 0', hasValue ? transformHelpers.legendPadding : 'padding: 0'), Label$2, labelTransformModifiers.moveUp, Fieldset, Legend, hasLabel && css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n        ", "\n      "])), labelTransformModifiers.legendVisible), colors.neutral_light, Fieldset, colors.neutral_light, Label$2, colors.neutral_light, colors.neutral, Fieldset, colors.neutral, Label$2, colors.neutral, Label$2, colors.neutral, Label$2, labelTransformModifiers.moveUp, Fieldset, Legend, labelTransformModifiers.legendVisible, colors.light);
});
var Legend = /*#__PURE__*/styled.legend(_templateObject19 || (_templateObject19 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /** NOTE: 1.05rem -> (1.4rem * 0.75) where:\n   * 1.4 is the \"label font size\"\n   * 0.75 is the \"scale factor in the transform\"\n   */\n  font-size: 1.05rem;\n\n  height: 0.5rem;\n  max-width: 0;\n  padding: 0;\n  transition: max-width 100ms cubic-bezier(0, 0, 0.2, 1) 50ms;\n  visibility: hidden;\n  width: auto;\n"])));
var Text = /*#__PURE__*/styled.p(_templateObject20 || (_templateObject20 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  bottom: -", ";\n  display: block;\n  font-size: 1rem;\n  left: ", ";\n  position: absolute;\n  cursor: initial;\n"])), spacing.medium, spacing.medium);
var Label$2 = /*#__PURE__*/styled.label(_templateObject21 || (_templateObject21 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: block;\n  left: 0;\n  padding: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  transform-origin: top left;\n  ", "\n  transition: all 0.25s ease, color 100ms cubic-bezier(0, 0, 0.2, 1) 50ms;\n  z-index: ", ";\n\n  ", "\n"])), labelTransformModifiers.moveDown, layers.above, typography.body_text_1);
var Icon = /*#__PURE__*/styled.div(_templateObject22 || (_templateObject22 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  margin-right: ", ";\n"])), spacing.medium);

var _excluded$2 = ["id", "value", "label", "helperText", "error", "variant", "as", "type", "disabled", "readonly", "onChange", "icon", "mask", "maskPlaceholder", "textTransform"];
var getMask = function getMask(mask) {
  var masks = {
    date: '99/99/9999'
  };
  return masks[mask] || mask;
};
var Field = function Field(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "id-" + nanoid() : _ref$id,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    label = _ref.label,
    helperText = _ref.helperText,
    error = _ref.error,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'input' : _ref$as,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$readonly = _ref.readonly,
    readonly = _ref$readonly === void 0 ? false : _ref$readonly,
    _onChange = _ref.onChange,
    icon = _ref.icon,
    mask = _ref.mask,
    maskPlaceholder = _ref.maskPlaceholder,
    textTransform = _ref.textTransform,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var _useState = useState(value),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  useEffect(function () {
    if (!value) setInputValue('');
    setInputValue(value);
  }, [value]);
  return React.createElement(Wrapper$3, {
    hasValue: !!inputValue,
    variant: error ? 'error' : variant
  }, React.createElement(Card, null, as === 'input' ? React.createElement(InputMask, _extends({
    mask: getMask(mask),
    maskPlaceholder: maskPlaceholder,
    readOnly: readonly,
    disabled: disabled,
    value: inputValue,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
      !!_onChange && _onChange(e);
    }
  }, props), React.createElement(Input$1, {
    id: id,
    hasValue: !!inputValue,
    as: as,
    type: type,
    textTransform: textTransform,
    hasLabel: !!label
  })) : React.createElement(Input$1, _extends({
    id: id,
    hasValue: !!inputValue,
    defaultValue: value,
    hasLabel: !!label,
    rows: 8,
    as: as,
    type: type,
    readOnly: readonly,
    disabled: disabled,
    onChange: function onChange(e) {
      setInputValue(e.target.value);
      !!_onChange && _onChange(e);
    }
  }, props)), React.createElement(Label$2, {
    htmlFor: id
  }, label), React.createElement(Fieldset, {
    "aria-hidden": true
  }, React.createElement(Legend, null, label)), !!icon && React.createElement(Icon, null, React.createElement(icons[icon], {
    width: 25,
    height: 25
  }))), React.createElement(Text, null, error != null ? error : helperText));
};

var _templateObject$6, _templateObject2$6, _templateObject3$5, _templateObject4$5, _templateObject5$4, _templateObject6$3, _templateObject7$2, _templateObject8$1, _templateObject9$1;
var Wrapper$2 = /*#__PURE__*/styled.div(_templateObject$6 || (_templateObject$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  border-radius: ", ";\n  border: ", " solid ", ";\n  display: flex;\n  flex-direction: column;\n  padding: ", ";\n  position: relative;\n  justify-content: center;\n  cursor: pointer;\n  height: ", ";\n  overflow: hidden;\n\n  ", ";\n"])), radius.small, borderWidths.thin, colors.primary, spacing.small, function (props) {
  return props.height ? props.height : '18.8rem';
}, /*#__PURE__*/media.greaterThan('tablet')(_templateObject2$6 || (_templateObject2$6 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n\n    &::after {\n      backdrop-filter: blur(24px);\n      background-color: ", ";\n      bottom: 0;\n      content: \"\";\n      height: 100%;\n      left: 0;\n      opacity: ", ";\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 100%;\n      z-index: -1;\n    }\n  "])), spacing.medium, colors.light, opacity.extreme));
var ContainerLabel = /*#__PURE__*/styled.p(_templateObject3$5 || (_templateObject3$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  color: ", ";\n  align-content: flex-end;\n"])), colors.neutral);
var FileUpload$1 = /*#__PURE__*/styled.input.attrs({
  type: 'file',
  hidden: true
})(_templateObject4$5 || (_templateObject4$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"])));
var ThumbnailGrid = /*#__PURE__*/styled.ul(_templateObject5$4 || (_templateObject5$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n  overflow-y: auto;\n\n  ", "\n"])), /*#__PURE__*/gap(gutter.small));
var Thumbnail = /*#__PURE__*/styled.img(_templateObject6$3 || (_templateObject6$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  filter: brightness(65%);\n  object-fit: cover;\n  transition: filter 0.25s ease;\n  height: 7rem;\n  width: 9.7rem;\n"])), radius.small);
var ThumbnailWrapper = /*#__PURE__*/styled.li(_templateObject7$2 || (_templateObject7$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n"])), colors.neutral_extra_light, radius.small);
var IconWrapper = /*#__PURE__*/styled.div(_templateObject8$1 || (_templateObject8$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  background-image: ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  display: flex;\n  height: 3.2rem;\n  justify-content: center;\n  left: 0;\n  margin-left: auto;\n  margin-right: auto;\n  position: absolute;\n  right: 0;\n  width: 3.2rem;\n"])), colors.gradient__primary_diagonal, radius.small);
var UploadButton = /*#__PURE__*/styled.li(_templateObject9$1 || (_templateObject9$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  height: 7rem;\n  justify-content: center;\n  position: relative;\n  width: 9.7rem;\n  border-radius: ", ";\n"])), colors.neutral_extra_light, radius.small);

var _excluded$1 = ["accept", "id", "label", "maxFileSize", "maxFilesAllowed", "multiple", "hasButton", "height", "onChange"];
var FileUpload = function FileUpload(_ref) {
  var _ref$accept = _ref.accept,
    accept = _ref$accept === void 0 ? 'image/*' : _ref$accept,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "filepload-" + nanoid() : _ref$id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Oppure seleziona l'immagine" : _ref$label,
    _ref$maxFileSize = _ref.maxFileSize,
    maxFileSize = _ref$maxFileSize === void 0 ? 2000 : _ref$maxFileSize,
    _ref$maxFilesAllowed = _ref.maxFilesAllowed,
    maxFilesAllowed = _ref$maxFilesAllowed === void 0 ? 10 : _ref$maxFilesAllowed,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? true : _ref$multiple,
    _ref$hasButton = _ref.hasButton,
    hasButton = _ref$hasButton === void 0 ? false : _ref$hasButton,
    height = _ref.height,
    onChange = _ref.onChange,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var _useState = useState([]),
    uploadedFiles = _useState[0],
    setUploadedFiles = _useState[1];
  var inputFileRef = useRef();
  var handleInputFileClick = function handleInputFileClick() {
    if (uploadedFiles.length === 0) {
      inputFileRef.current.click();
    }
    return;
  };
  var handleFilesValidation = useCallback(function (fileList) {
    if (uploadedFiles.length >= maxFilesAllowed || uploadedFiles.length >= 10) {
      fileList = [];
      alert("Maximum number of files to upload is: " + maxFilesAllowed);
      return fileList;
    }
    fileList.forEach(function (file, index) {
      var fileSize = Math.round(file.size / 1024);
      var allowedSizeInMB = Math.round(maxFileSize / 1024);
      if (fileSize > maxFileSize) {
        fileList.splice(index, 1);
        alert("Maximum size allowed for a file is: " + allowedSizeInMB + "MB");
        return fileList;
      }
      return null;
    });
    return fileList;
  }, [maxFileSize, maxFilesAllowed, uploadedFiles.length]);
  var handleInputDrop = function handleInputDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    var newUploadedFiles = Array.from(event.dataTransfer.files);
    setUploadedFiles([].concat(uploadedFiles, handleFilesValidation(newUploadedFiles)));
  };
  var handleSelectedFiles = function handleSelectedFiles(event) {
    var _event$target;
    var newUploadedFiles = Array.from(((_event$target = event.target) == null ? void 0 : _event$target.files) || []);
    setUploadedFiles([].concat(uploadedFiles, handleFilesValidation(newUploadedFiles)));
  };
  var handleOnChange = function handleOnChange(event) {
    handleSelectedFiles(event);
    onChange(event);
  };
  var handleDeleteFile = function handleDeleteFile(indexToDelete) {
    setUploadedFiles(uploadedFiles.filter(function (_, index) {
      return index !== indexToDelete;
    }));
  };
  return React.createElement(React.Fragment, null, React.createElement(Wrapper$2, {
    onClick: handleInputFileClick,
    onDragOver: function onDragOver(event) {
      return event.preventDefault();
    },
    onDrop: handleInputDrop,
    draggable: true,
    height: height
  }, React.createElement(FileUpload$1, _extends({
    "aria-label": "upload input",
    id: id,
    accept: accept,
    maxFileSize: maxFileSize,
    maxFilesAllowed: maxFilesAllowed,
    multiple: multiple,
    onChange: handleOnChange,
    ref: inputFileRef
  }, props)), uploadedFiles.length === 0 ? React.createElement(React.Fragment, null, React.createElement(Cloud, {
    color: "secondary",
    width: 160,
    height: 124
  }), label && !hasButton && React.createElement(ContainerLabel, null, label)) : React.createElement(ThumbnailGrid, null, React.createElement(UploadButton, {
    "aria-label": "upload button",
    onClick: function onClick() {
      inputFileRef.current.click();
    }
  }, React.createElement(IconWrapper, null, React.createElement(Cloud, {
    color: "light",
    width: 18,
    height: 18
  }))), uploadedFiles.map(function (file, index) {
    return React.createElement(ThumbnailWrapper, {
      key: file.name + "-" + index,
      onClick: function onClick() {
        return handleDeleteFile(index);
      }
    }, React.createElement(Thumbnail, {
      src: URL.createObjectURL(file)
    }), React.createElement(IconWrapper, null, React.createElement(Delete, {
      color: "light",
      width: 18,
      height: 18
    })));
  }))), hasButton && React.createElement(Button$2, {
    icon: "cloud",
    variant: "outline",
    extended: true,
    as: "label",
    htmlFor: id
  }, label));
};

var _templateObject$5, _templateObject2$5, _templateObject3$4, _templateObject4$4, _templateObject5$3, _templateObject6$2, _templateObject7$1, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
var SizeModifiers = {
  small: /*#__PURE__*/css(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    min-height: initial;\n\n    ", "\n  "])), /*#__PURE__*/media.greaterThan('tablet')(_templateObject2$5 || (_templateObject2$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n      max-width: 36rem;\n    "])))),
  medium: /*#__PURE__*/css(_templateObject3$4 || (_templateObject3$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 50rem;\n  "]))),
  large: /*#__PURE__*/css(_templateObject4$4 || (_templateObject4$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    max-width: 102.4rem;\n  "]))),
  full: /*#__PURE__*/css(_templateObject5$3 || (_templateObject5$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    min-height: 100%;\n  "])))
};
var ModalContainer = /*#__PURE__*/styled.div(_templateObject6$2 || (_templateObject6$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var size = _ref.size;
  return css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-radius: ", ";\n    min-height: 40rem;\n    padding: ", ";\n    width: 100%;\n\n    ", "\n  "])), colors.light, radius.medium, spacing.medium, !!size && SizeModifiers[size]);
});
var positionXModifier = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
};
var positionYModifier = {
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center'
};
/**
 * Turn this into a dialog
 */
var Backdrop = /*#__PURE__*/styled.section(_templateObject8 || (_templateObject8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var open = _ref2.open,
    variant = _ref2.variant,
    animationOptions = _ref2.animationOptions,
    _ref2$positionX = _ref2.positionX,
    positionX = _ref2$positionX === void 0 ? 'center' : _ref2$positionX,
    _ref2$positionY = _ref2.positionY,
    positionY = _ref2$positionY === void 0 ? 'center' : _ref2$positionY;
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    padding: ", ";\n    align-items: ", ";\n    background-color: ", ";\n    display: flex;\n    justify-content: ", ";\n    opacity: 0;\n    position: fixed;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    transition: ", ";\n    visibility: hidden;\n    pointer-events: none;\n    z-index: ", ";\n\n    ", "\n\n    ", " {\n      box-shadow: ", ";\n      opacity: 0;\n      transform: translateY(2rem);\n      transition: ", ";\n    }\n\n    ", "\n  "])), gutter.small, positionYModifier[positionY], rgba(colors.dark, opacity.hard), positionXModifier[positionX], (animationOptions == null ? void 0 : animationOptions.leave) && 'all 0.45s ease', layers.modal, !!open && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n      transition: ", ";\n    "])), (animationOptions == null ? void 0 : animationOptions.enter) && 'all 0.45s ease'), ModalContainer, variant === 'shadow' && shadows["default"], (animationOptions == null ? void 0 : animationOptions.leave) && 'all 0.25s ease', !!open && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n      opacity: 1;\n      pointer-events: initial;\n      visibility: visible;\n\n      ", " {\n        opacity: 1;\n        transform: translateY(0);\n        transition: ", ";\n      }\n    "])), ModalContainer, (animationOptions == null ? void 0 : animationOptions.enter) && 'all 0.35s ease 0.15s'));
});
var Header = /*#__PURE__*/styled.div(_templateObject12 || (_templateObject12 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: ", ";\n"])), spacing.small);
var CloseButton = /*#__PURE__*/styled.button.attrs({
  type: 'button'
})(_templateObject13 || (_templateObject13 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"])));

var Modal = function Modal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    _ref$dismissible = _ref.dismissible,
    dismissible = _ref$dismissible === void 0 ? false : _ref$dismissible,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$positionX = _ref.positionX,
    positionX = _ref$positionX === void 0 ? 'center' : _ref$positionX,
    _ref$positionY = _ref.positionY,
    positionY = _ref$positionY === void 0 ? 'center' : _ref$positionY,
    _ref$closeButtonColor = _ref.closeButtonColor,
    closeButtonColor = _ref$closeButtonColor === void 0 ? 'secondary' : _ref$closeButtonColor,
    _ref$animationOptions = _ref.animationOptions,
    animationOptions = _ref$animationOptions === void 0 ? {
      enter: true,
      leave: true
    } : _ref$animationOptions,
    children = _ref.children;
  var modalRef = useRef(null);
  var backdropRef = useRef(null);
  var handleClose = function handleClose(_ref2) {
    var key = _ref2.key;
    if (key === 'Escape') {
      onClose();
    }
  };
  var handleClick = function handleClick(_ref3) {
    var _modalRef$current;
    var target = _ref3.target;
    return !(modalRef != null && (_modalRef$current = modalRef.current) != null && _modalRef$current.contains(target)) && onClose();
  };
  useEffect(function () {
    if (dismissible) {
      var _backdropRef$current;
      window.addEventListener('keydown', handleClose, false);
      backdropRef == null || (_backdropRef$current = backdropRef.current) == null || _backdropRef$current.addEventListener('click', handleClick, false);
    }
    return function () {
      var _backdropRef$current2;
      window.removeEventListener('keydown', handleClose, false);
      backdropRef == null || (_backdropRef$current2 = backdropRef.current) == null || _backdropRef$current2.removeEventListener('click', handleClick, false);
    };
  }, [dismissible]);
  return React.createElement(Backdrop, {
    ref: backdropRef,
    "aria-label": "modal area",
    animationOptions: animationOptions,
    open: open,
    variant: variant,
    "aria-hidden": !open,
    positionX: positionX,
    positionY: positionY
  }, React.createElement(ModalContainer, {
    size: size,
    ref: modalRef
  }, dismissible && showCloseButton && React.createElement(Header, null, React.createElement(CloseButton, {
    onClick: onClose
  }, React.createElement(CloseCircleOutline, {
    width: 24,
    height: 24,
    color: closeButtonColor
  }))), children));
};

var RadioGroupContext = /*#__PURE__*/createContext({});
var RadioGroupProvider = function RadioGroupProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    radioGroupName = _useState[0],
    setRadioGroupName = _useState[1];
  var _useState2 = useState('secondary'),
    color = _useState2[0],
    setColor = _useState2[1];
  var _useState3 = useState(false),
    isError = _useState3[0],
    setIsError = _useState3[1];
  return React.createElement(RadioGroupContext.Provider, {
    value: {
      radioGroupName: radioGroupName,
      setRadioGroupName: setRadioGroupName,
      color: color,
      setColor: setColor,
      isError: isError,
      setIsError: setIsError
    }
  }, children);
};
var useRadioGroup = function useRadioGroup() {
  var context = useContext(RadioGroupContext);
  if (!context) {
    throw new Error('useRadioGroup hook must be used under CitySelectionProvider');
  }
  return context;
};

var _templateObject$4, _templateObject2$4, _templateObject3$3, _templateObject4$3;
var RadioLabel = /*#__PURE__*/styled.label(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
var RadioInput = /*#__PURE__*/styled.input.attrs({
  type: 'radio'
})(_templateObject2$4 || (_templateObject2$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var color = _ref.color;
  return css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n    display: grid;\n    place-content: center;\n    appearance: none;\n    background-color: transparent;\n    margin: 0 ", " 0 0;\n    width: 2.4rem;\n    height: 2.4rem;\n    border: ", " solid\n      ", ";\n    border-radius: ", ";\n    flex-shrink: 0;\n    cursor: pointer;\n\n    &::before {\n      content: '';\n      width: 1.2rem;\n      height: 1.2rem;\n      border-radius: 50%;\n      transform: scale(0);\n      transition: 0.2s transform ease-in-out;\n      background-color: ", ";\n    }\n\n    &:checked::before {\n      transform: scale(1);\n    }\n  "])), spacing.small, borderWidths.thin, color ? colors[color] : colors.secondary, radius.large, color ? colors[color] : colors.secondary);
});
var RadioContent = /*#__PURE__*/styled.span(_templateObject4$3 || (_templateObject4$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n\n  color: ", ";\n"])), typography.body_text_1, function (_ref2) {
  var isError = _ref2.isError;
  return isError ? colors.state__error : colors.dark;
});

var Input = function Input(_ref) {
  var inputColor = _ref.inputColor,
    inputName = _ref.inputName,
    id = _ref.id,
    label = _ref.label;
  var _useRadioGroup = useRadioGroup(),
    color = _useRadioGroup.color,
    radioGroupName = _useRadioGroup.radioGroupName,
    isError = _useRadioGroup.isError;
  return React.createElement(RadioLabel, {
    htmlFor: id
  }, React.createElement(RadioInput, {
    name: inputName != null ? inputName : radioGroupName,
    value: id,
    id: id,
    color: inputColor != null ? inputColor : color
  }), React.createElement(RadioContent, {
    isError: isError
  }, label));
};

var _templateObject$3, _templateObject2$3, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1;
var OuterWrapper = /*#__PURE__*/styled.div(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var RadioGroupWrapper = /*#__PURE__*/styled.fieldset(_templateObject2$3 || (_templateObject2$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var color = _ref.color,
    error = _ref.error;
  return css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    border: ", " solid\n      ", ";\n    border-radius: ", ";\n    padding: ", ";\n    display: grid;\n    margin-bottom: ", ";\n    position: relative;\n    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));\n    gap: ", ";\n    justify-content: flex-start;\n  "])), borderWidths.thin, color ? colors[color] : colors.secondary, radius.small, spacing.medium, error ? '3rem' : '0', spacing.medium);
});
var scaleLabel = 0.75;
var transformXPosition = "calc(" + gutter["default"] + " - " + scaleLabel + "rem)";
var Label$1 = /*#__PURE__*/styled.p(_templateObject4$2 || (_templateObject4$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", ";\n"])), function (_ref2) {
  var error = _ref2.error;
  return css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    display: block;\n    padding: 0 ", " !important;\n    left: 0;\n    padding: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    background-color: ", ";\n    // NOTE: 0.7 it's equivalent to half the height of body_text_1.\n    transform: translate(", ", -0.7rem) scale(", ");\n    z-index: ", ";\n\n    ", ";\n  "])), error ? colors.state__error : rgba(colors.dark, 0.65), spacing.small, colors.light, transformXPosition, scaleLabel, layers.above, typography.body_text_1);
});
var ErrorText = /*#__PURE__*/styled.p(_templateObject6$1 || (_templateObject6$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  bottom: -", ";\n  display: block;\n  font-size: 1rem;\n  position: absolute;\n  color: ", ";\n"])), spacing.medium, colors.state__error);

var RadioContainer = function RadioContainer(_ref) {
  var groupLabel = _ref.groupLabel,
    color = _ref.color,
    radioGroupName = _ref.radioGroupName,
    error = _ref.error,
    handleChange = _ref.handleChange,
    children = _ref.children;
  var _useRadioGroup = useRadioGroup(),
    setRadioGroupName = _useRadioGroup.setRadioGroupName,
    setColor = _useRadioGroup.setColor,
    setIsError = _useRadioGroup.setIsError;
  useEffect(function () {
    setRadioGroupName(radioGroupName);
    setColor(color);
    setIsError(!!error);
  }, [setRadioGroupName, radioGroupName, setColor, color, handleChange, setIsError, error]);
  return React.createElement(OuterWrapper, null, groupLabel && React.createElement(Label$1, {
    error: !!error
  }, groupLabel), React.createElement(RadioGroupWrapper, {
    color: color,
    onChange: handleChange,
    error: !!error
  }, children, error && React.createElement(ErrorText, null, error)));
};

var RadioGroup = function RadioGroup(_ref) {
  var groupLabel = _ref.groupLabel,
    color = _ref.color,
    radioGroupName = _ref.radioGroupName,
    error = _ref.error,
    handleChange = _ref.handleChange,
    children = _ref.children;
  return React.createElement(StyleSheetManager, {
    enableVendorPrefixes: true
  }, React.createElement(RadioGroupProvider, null, React.createElement(RadioContainer, {
    groupLabel: groupLabel,
    radioGroupName: radioGroupName,
    color: color,
    handleChange: handleChange,
    error: error
  }, children)));
};
RadioGroup.Input = Input;

var _templateObject$2, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7;
var colorMapper = {
  primary: colors.primary,
  secondary: colors.secondary,
  error: colors.state__error,
  dark: colors.dark
};
var Wrapper$1 = /*#__PURE__*/styled.div(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    readonly = _ref.readonly;
  return css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n    position: relative;\n    font-family: inherit;\n    width: 100%;\n    cursor: ", ";\n\n    .pantheon-select {\n      &__control {\n        border-color: ", ";\n        border-radius: ", ";\n        height: 4.5rem;\n        pointer-events: ", ";\n\n        &:hover {\n          border-color: ", ";\n        }\n\n        &--is-focused {\n          box-shadow: none;\n        }\n\n        &--menu-is-open {\n          .pantheon-select__dropdown-indicator {\n            transform: rotate(180deg);\n          }\n        }\n      }\n\n      &__input-container {\n        ", ";\n        color: ", ";\n      }\n\n      &__value-container {\n        padding-left: ", ";\n      }\n\n      &__single-value {\n        ", ";\n\n        ", "\n      }\n\n      &__placeholder {\n        color: ", ";\n\n        ", ";\n      }\n\n      &__indicator-separator {\n        background-color: ", ";\n      }\n\n      &__dropdown-indicator {\n        svg {\n          fill: ", ";\n        }\n      }\n\n      &__menu {\n        z-index: ", ";\n        border-radius: ", ";\n        border: 0.1rem solid ", ";\n        box-shadow: ", ";\n\n        &-list {\n          padding-top: calc(", " + 5px);\n          padding-bottom: calc(", " + 5px);\n        }\n      }\n\n      &__option {\n        padding-left: ", ";\n        ", ";\n\n        &--is-focused {\n          background-color: transparent;\n        }\n\n        &:hover {\n          background-color: ", ";\n        }\n\n        &--is-selected {\n          background-color: ", ";\n          color: ", ";\n        }\n      }\n    }\n  "])), readonly ? 'not-allowed' : 'pointer', readonly ? colors.neutral : colorMapper[variant], radius.small, readonly ? 'none' : 'all', readonly ? colors.neutral : colorMapper[variant], typography.body_text_1, colors.text__primary, gutter["default"], typography.body_text_1, readonly && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n          color: ", ";\n        "])), colors.neutral), readonly ? colors.neutral : colorMapper[variant], typography.body_text_1, colors.neutral_extra_light, readonly ? colors.neutral : colorMapper[variant], layers.alert, radius.small, colorMapper[variant], shadows.soft, gutter.small, gutter.small, gutter["default"], typography.body_text_1, colors.neutral_extra_light, colors.neutral_extra_light, colorMapper[variant]);
});
var Label = /*#__PURE__*/styled.label(_templateObject4$1 || (_templateObject4$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var filled = _ref2.filled,
    variant = _ref2.variant,
    readonly = _ref2.readonly;
  return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    left: 0;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    opacity: 0;\n    background-color: ", ";\n    pointer-events: none;\n    transition: opacity 0.2s linear, top 0.2s linear, font-size 0.2s linear,\n      color 0.2s linear;\n    will-change: opacity, top, font-size, color;\n    padding: 0 11px;\n    z-index: ", ";\n\n    ", ";\n\n    ", "\n  "])), readonly ? colors.neutral : colorMapper[variant], colors.light, layers.above, typography.body_text_1, filled && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n      top: 0;\n      font-size: 10.5px;\n      opacity: 1;\n      padding: 0 10px 0 5px;\n      left: ", ";\n    "])), gutter["default"]));
});
var HelperText = /*#__PURE__*/styled.p(_templateObject7 || (_templateObject7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  cursor: initial;\n  font-size: 1rem;\n  margin: ", " 0 ", ";\n  padding-left: 2.5rem;\n  color: ", ";\n"])), gutter.small, spacing.medium, function (_ref3) {
  var isError = _ref3.isError;
  return isError ? colors.state__error : colors.text__primary;
});

var Select = function Select(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? "id-" + nanoid() : _ref$id,
    _ref$searchable = _ref.searchable,
    searchable = _ref$searchable === void 0 ? false : _ref$searchable,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$noOptionsMessage = _ref.noOptionsMessage,
    _noOptionsMessage = _ref$noOptionsMessage === void 0 ? 'Nessuna opzione' : _ref$noOptionsMessage,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    error = _ref.error,
    value = _ref.value,
    label = _ref.label,
    options = _ref.options,
    helperText = _ref.helperText,
    _onChange = _ref.onChange,
    _ref$readonly = _ref.readonly,
    readonly = _ref$readonly === void 0 ? false : _ref$readonly;
  var _useState = useState(value),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  return React.createElement(Wrapper$1, {
    variant: error ? 'error' : variant,
    readonly: readonly
  }, React.createElement(Label, {
    htmlFor: id,
    filled: Array.isArray(inputValue) ? !!inputValue.length : !!inputValue,
    variant: variant,
    readonly: readonly
  }, label), React.createElement(ReactSelect, {
    id: id,
    value: value,
    options: options,
    isSearchable: searchable,
    isMulti: multiple,
    isDisabled: disabled,
    onChange: function onChange(newValue) {
      setInputValue(newValue);
      _onChange && _onChange(newValue);
    },
    placeholder: label,
    noOptionsMessage: function noOptionsMessage() {
      return _noOptionsMessage;
    },
    classNamePrefix: "pantheon-select"
  }), (error || helperText) && React.createElement(HelperText, {
    isError: !!error
  }, error || helperText));
};

var textConverter = /*#__PURE__*/new showdown.Converter();
var textDecoder = function textDecoder(content, encoded) {
  var decodedText = content;
  if (encoded) {
    decodedText = textConverter.makeMarkdown(decodedText);
  }
  return decodedText;
};

var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5;
var Button = /*#__PURE__*/styled(Button$2).attrs(function () {
  return {
    variant: 'overlay'
  };
})(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var open = _ref.open;
  return css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    height: auto;\n    min-width: auto;\n    ", "\n\n    span {\n      ", "\n      font-weight: ", ";\n    }\n  "])), open && 'padding: 0;', new_typography.body_text_3, font_weight.medium);
});
var Wrapper = /*#__PURE__*/styled.div(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose([""])));
var InlineTypography = /*#__PURE__*/styled(NewTypography)(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var open = _ref2.open;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    display: ", ";\n  "])), open ? 'inline-block' : 'inline');
});

var TextToggle = function TextToggle(_ref) {
  var content = _ref.content,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 100 : _ref$limit,
    _ref$toggleClose = _ref.toggleClose,
    toggleClose = _ref$toggleClose === void 0 ? 'Vedi meno' : _ref$toggleClose,
    _ref$toggleOpen = _ref.toggleOpen,
    toggleOpen = _ref$toggleOpen === void 0 ? 'Scopri di più' : _ref$toggleOpen,
    onClick = _ref.onClick,
    open = _ref.open,
    encoded = _ref.encoded;
  var text = textDecoder(content, encoded);
  if (content.length <= limit && typeof content === 'string') {
    return React.createElement(Wrapper, null, React.createElement(InlineTypography, {
      marginBottom: "none",
      variant: "body_text_3",
      color: "text__primary",
      open: true
    }, text));
  }
  return React.createElement(Wrapper, null, React.createElement(InlineTypography, {
    marginBottom: "none",
    variant: "body_text_3",
    color: "text__primary",
    open: open
  }, open ? text : text.substring(0, limit) + "..."), typeof toggleClose !== 'string' ? React.createElement("span", {
    onClick: onClick
  }, toggleClose) : open && React.createElement(Button, {
    open: open,
    onClick: onClick
  }, toggleClose), typeof toggleOpen !== 'string' ? React.createElement("span", {
    onClick: onClick
  }, toggleOpen) : !open && React.createElement(Button, {
    open: open,
    onClick: onClick
  }, toggleOpen));
};

var _templateObject, _templateObject2;
var Typography$1 = /*#__PURE__*/styled.p(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    marginTop = _ref.marginTop,
    marginBottom = _ref.marginBottom,
    textAlign = _ref.textAlign;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    text-align: ", ";\n    word-break: break-word;\n\n    ", ";\n  "])), colors[color], spacing[marginTop], spacing[marginBottom], textAlign, variant && typography[variant]);
});

var _excluded = ["as", "variant", "color", "marginTop", "marginBottom", "textAlign", "children"];
// eslint-disable-next-line react/display-name
var Typography = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'p' : _ref$as,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body_text_1' : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'text__primary' : _ref$color,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? 'none' : _ref$marginBottom,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'inherit' : _ref$textAlign,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(Typography$1, _extends({
    as: as,
    variant: variant,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    textAlign: textAlign,
    ref: ref
  }, props), children);
});

var getScreenDimentions = function getScreenDimentions() {
  if (typeof window === 'undefined') {
    return {
      width: 0,
      height: 0
    };
  }
  return {
    width: window.innerWidth,
    height: window.innerHeight
  };
};
var useScreenDimentions = function useScreenDimentions() {
  var _useState = useState(0),
    windowHeight = _useState[0],
    setWindowHeight = _useState[1];
  var _useState2 = useState(0),
    windowWidth = _useState2[0],
    setWindowWidth = _useState2[1];
  var setScreenDimentions = function setScreenDimentions() {
    var _getScreenDimentions = getScreenDimentions(),
      height = _getScreenDimentions.height,
      width = _getScreenDimentions.width;
    setWindowHeight(height);
    setWindowWidth(width);
  };
  useEffect(function () {
    setScreenDimentions();
    window.addEventListener('resize', setScreenDimentions);
    return function () {
      return window.removeEventListener('resize', setScreenDimentions);
    };
  }, []);
  return {
    windowWidth: windowWidth,
    windowHeight: windowHeight
  };
};

var OS;
(function (OS) {
  OS["ios"] = "iOS";
  OS["macos"] = "macOS";
  OS["android"] = "Android";
  OS["windows"] = "Windows";
  OS["linux"] = "Linux";
})(OS || (OS = {}));

export { Accordion, ArrowDown, Autocomplete, Blood, BulletCarousel, Button$2 as Button, CSSReset, Calendar, CalendarCheck, Card$1 as Card, Carousel, Chat, ChatPlusOne, ChatQuestion, ChatSquareText, Check, CheckedCheckbox, Clock, Close, CloseCircle, CloseCircleOutline, Cloud, Delete, Divider, Doctor, Drawer, Edit, Face, Facebook, Field, FileEarmarkCheckFill, FileUpload, Grid, HandDraw, House, HouseAddress, InfoCircle, Instagram, Linkedin, Loading, Location, Mail, MailSimple, MediaMatch, MedicalNote, Menu, MessageError, MinusCircle, Modal, NewTypography, NotebookQuestion, Nurse, OS, Password, PlusCircle, QuestionCircle, RadioGroup, RefreshCircle, RoundButton, Search, Secure, Select, SelectableAccordion, Send, Share, Spinner, Star, Telephone, TextToggle, ThinArrow, Time, Timer, Typography, User, Users, ViewportProvider, Virus, Warning, Whatsapp, Xray, borderWidths, breakpoints, colors, desktop_small_height_mixin, desktop_small_mixin, firefoxOnly, font_family, font_weight, gap, getBrowserParser, gutter, icons, isDesktopSmall, isDesktopSmallHeight, isMobileKeyboardOpen, isMobileLarge, isMobileSmall, layers, line_height, media, mobile_keyboard_open_mixin, mobile_large_mixin, mobile_small_mixin, new_typography, opacity, paragraph_spacing, radius, scrollBar, shadows, spacing, transitions, typography, useScreenDimentions, useUserDevice, useViewport };
//# sourceMappingURL=pantheon.esm.js.map
